/*
@license
  Be Yours by roartheme (https://roartheme.co)
  Access unminified JS in assets/global.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://roartheme.co/blogs/beyours/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/
window.theme = window.theme || {};

theme.config = {
  mqlSmall: false,
  mediaQuerySmall: 'screen and (max-width: 749px)',
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  rtl: document.documentElement.getAttribute('dir') === 'rtl' ? true : false
};

if (console && console.log) {
  console.log(theme.settings.themeName + ' theme (' + theme.settings.themeVersion + ') by RoarTheme | Learn more at https://roartheme.co');
}

theme.Currency = (function () {
  const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
      variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit
  };
})();

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, { rootMargin: `0px 0px ${threshold}px 0px` });

  observer.observe(options.element);
};

(function () {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(theme.config.mediaQuerySmall);
  theme.config.mqlSmall = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      theme.config.mqlSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.mqlSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  }

  // Page transition
  window.addEventListener('beforeunload', () => {
    document.body.classList.add('unloading');
  });
  window.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('loaded');

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });
  window.addEventListener('pageshow', (event) => {
    // Removes unload class when returning to page via history
    if (event.persisted) {
      document.body.classList.remove('unloading');
    }
  });

  // Viewport height
  function viewportHeight() {
    if (window.matchMedia('(max-width: 990px)')) {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    setHeaderBottomPosition();
  }
  window.addEventListener('resize', viewportHeight);
  window.addEventListener('DOMContentLoaded', viewportHeight);

  if (document.body.getAttribute('data-page-rendering') !== null) {
    // Improve initial load time by skipping the rendering of offscreen content
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          const el = entry.target;
          // Not currently in intersection area.
          if (entry.intersectionRatio == 0) {
            return;
          }
          // Trigger rendering for elements within scroll area that haven't already been marked.
          if (!el.markedVisible) {
            el.attributeStyleMap && el.attributeStyleMap.set('content-visibility', 'visible');
            el.markedVisible = true;
          }
        });
      },
      // Set a rendering 50px above and 100px below the main scroll area.
      { rootMargin: '50px 0px 100px 0px' }
    );
    const sections = document.querySelectorAll('.shopify-section + .shopify-section');
    sections.forEach((section) => { observer.observe(section); });
  }

  /*
  // Delay JavaScript until user interaction
  const loadScriptsTimer = setTimeout(loadScripts, 5000);
  const userInteractionEvents = ["mouseover", "mousemove", "keydown", "touchstart", "touchend", "touchmove", "wheel"];
  userInteractionEvents.forEach(function(event) {
    window.addEventListener(event, triggerScriptLoader, {
      passive: !0
    });
  });
  function triggerScriptLoader() {
    loadScripts();
    clearTimeout(loadScriptsTimer);
    userInteractionEvents.forEach(function(event) {
      window.removeEventListener(event, triggerScriptLoader, {
        passive: !0
      });
    });
  }
  function loadScripts() {
    document.querySelectorAll("script[data-type='lazy']").forEach(function(script) {
      script.setAttribute("src", script.getAttribute("data-src"));
    });
  }
  */
})();

// Prevent vertical scroll while using flickity sliders
(function () {
  var e = !1;
  var t;

  document.body.addEventListener('touchstart', function (i) {
    if (!i.target.closest('.flickity-slider')) {
      return e = !1;
    }
    e = !0;
    t = {
      x: i.touches[0].pageX,
      y: i.touches[0].pageY
    }
  })

  document.body.addEventListener('touchmove', function (i) {
    if (e && i.cancelable) {
      var n = {
        x: i.touches[0].pageX - t.x,
        y: i.touches[0].pageY - t.y
      };
      Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
    }
  }, { passive: !1 })
})();

function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = 'beyours:test';
  let storage;
  if (type === 'session') {
    storage = window.sessionStorage;
  }
  if (type === 'local') {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  }
  catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

function checkScrollbar() {
  const rect = document.body.getBoundingClientRect();
  return Math.round(rect.left + rect.right) < window.innerWidth;
}

function setScrollbarWidth() {
  if (checkScrollbar()) {
    const element = document.createElement('span');
    element.className = 'modal-scrollbar-measure', document.body.appendChild(element);

    const width = element.getBoundingClientRect().width - element.clientWidth;
    document.body.removeChild(element);
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
  }
}

function setHeaderBottomPosition() {
  const header = document.querySelector('.shopify-section-header');
  if (header) {
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(header.getBoundingClientRect().bottom)}px`);
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'TAB') return; // If not TAB key

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('iframe.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('iframe.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video-section[data-type="youtube"]:not([data-video-hero]) iframe').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('video-section[data-type="vimeo"]:not([data-video-hero]) iframe').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => {
    if (!video.closest('[data-video-hero]')) video.pause();
  });
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
  if (charCode !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes('shopify:section')) {
    if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) {
      executeCallback = true;
    }
  }
  else if (event.type.includes('shopify:block') && event.target === domElement) {
    executeCallback = true;
  }
  if (executeCallback) {
    callback(event);
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.postLink2 = function (path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    for (const index in params[key]) {
      for (const key2 in params[key][index]) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", `${key}[${index}][${key2}]`);
        hiddenField.setAttribute("value", params[key][index][key2]);
        form.appendChild(hiddenField);
      }
    }
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    const limitSetting = window.max_limits?.max_limit;

    this.maxQty = (!limitSetting || parseInt(limitSetting, 10) === 0)
      ? Infinity
      : parseInt(limitSetting, 10);

    this.messageEl = null;
    this.init();
  }

  init() {
    this.input = this.querySelector('.quantity__input');
    this.changeEvent = new Event('change', { bubbles: true });

    // Button click events
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    // Input events
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    this.input.addEventListener('change', this.onInputChange.bind(this));

    // Find wrapper with class "product-quantity"
    const wrapper = this.closest('.product-quantity');
    if (wrapper && !this.messageEl) {
      this.messageEl = document.createElement('div');
      this.messageEl.className = 'qty-message';
      this.messageEl.style.display = 'none';
      wrapper.insertAdjacentElement('afterend', this.messageEl);
    }

    this.updateButtonState();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = parseInt(this.input.value, 10);

    if (event.target.name === 'plus') {
      if (previousValue < this.maxQty) {
        this.input.stepUp();
        this.hideMessage();
      } else {
        // User tried to go beyond limit → show error
        this.showMessage(`You can only add ${this.maxQty} of this item to your cart`);
      }
    } else {
      this.input.stepDown();
      this.hideMessage(); // hide error if reducing
    }

    if (previousValue !== parseInt(this.input.value, 10)) {
      this.input.dispatchEvent(this.changeEvent);
    }
    this.updateButtonState();
  }

  onInputChange() {
    let value = parseInt(this.input.value, 10) || 1;

    if (value > this.maxQty && this.maxQty !== Infinity) {
      this.input.value = this.maxQty;
      this.showMessage(`You can only add ${this.maxQty} of this item to your cart`);
    } else if (value < 1) {
      this.input.value = 1;
    } else {
      this.hideMessage();
    }

    this.updateButtonState();
  }

  onInputFocus() {
    this.input.select();
  }

  updateButtonState() {
    const plusBtn = this.querySelector('button[name="plus"]');
    const minusBtn = this.querySelector('button[name="minus"]');
    const value = parseInt(this.input.value, 10);

    if (this.maxQty !== Infinity) {
      plusBtn.disabled = false; // keep enabled, let user trigger error
      this.input.disabled = false;
    } else {
      plusBtn.disabled = false;
      this.input.disabled = false;
      this.hideMessage();
    }

    // Disable – button at min
    minusBtn.disabled = value <= 1;
  }

  showMessage(msg) {
    if (this.messageEl) {
      this.messageEl.innerText = msg;
      this.messageEl.style.display = 'block';
    }
  }

  hideMessage() {
    if (this.messageEl) {
      this.messageEl.style.display = 'none';
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class DrawerCloseButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => this.dispatchEvent(new CustomEvent('drawer:force-close', { bubbles: true, cancelable: true, composed: true })));
  }
}
customElements.define('drawer-close-button', DrawerCloseButton);

// --- Global Carousel Setup ---
let prevBtn, nextBtn;
let giftCarouselInitialized = false;

function setupGiftCarousel() {
  const carousel = document.querySelector('.gifts-on-cart-carousel');
  const newPrevBtn = document.querySelector('.gifts-carousel-prev');
  const newNextBtn = document.querySelector('.gifts-carousel-next');
  const giftItems = carousel?.querySelectorAll('.gift-item') || [];

  if (carousel && newPrevBtn && newNextBtn) {
    if (newPrevBtn !== prevBtn || newNextBtn !== nextBtn) {
      giftCarouselInitialized = false;
      prevBtn = newPrevBtn;
      nextBtn = newNextBtn;
    }

    if (giftItems.length > 3) {
      prevBtn.style.display = 'block';
      nextBtn.style.display = 'block';
    } else {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }

    if (!giftCarouselInitialized) {
      prevBtn.addEventListener('click', () => {
        carousel.scrollBy({ left: -200, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        carousel.scrollBy({ left: 200, behavior: 'smooth' });
      });

      giftCarouselInitialized = true;
    }

    return true;
  }

  return false;
}

// --- Listen for cart updates ---
document.addEventListener('DOMContentLoaded', () => {
  // Try to setup once on load
  setupGiftCarousel();

  // Retry for up to 10 seconds (useful for AJAX-loaded content)
  const interval = setInterval(() => {
    if (setupGiftCarousel()) clearInterval(interval);
  }, 300);
  setTimeout(() => clearInterval(interval), 10000);

  // Optional: Listen to custom cart event (if your theme dispatches one)
  document.addEventListener('cart:updated', () => {
    setupGiftCarousel();
  });

  // MutationObserver fallback for AJAX cart content
  const cartContainer =
    document.querySelector('#cart-form') ||
    document.querySelector('.cart-drawer') ||
    document.querySelector('.ajaxcart');

  if (cartContainer) {
    const observer = new MutationObserver(() => {
      setupGiftCarousel();
    });

    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }
});

// --- MenuDrawer Class ---
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      open: 'menu-drawer--open',
      opening: 'menu-drawer--opening',
      closing: 'menu-drawer--closing'
    };

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  setClasses(classes) {
    this.classes = classes;
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button[data-close]').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));

    this.addEventListener('drawer:force-close', (event) => {
      event.stopPropagation();
      this.closeMenuDrawer(event);
    });
  }

  onKeyUp(event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement = false) {
    setScrollbarWidth?.();
    setHeaderBottomPosition?.();

    if (summaryElement) {
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus?.(this.mainDetailsToggle, summaryElement);
    }

    setTimeout(() => {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      document.body.addEventListener('click', this.onBodyClickEvent);
    });
    document.body.classList.add(this.classes.opening);

    this.openAnimation();

    setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', '');
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      }, 10);
    });

    // Run gift carousel in case it's already in DOM
    setupGiftCarousel();
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.classList.add('menu-closing');
      removeTrapFocus?.(elementToFocus);

      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove(this.classes.open);
      document.body.classList.add(this.classes.closing);

      this.closeAnimation(this.mainDetailsToggle);
      this.dispatchEvent(new CustomEvent('close'));
      document.dispatchEvent(new CustomEvent('menudrawer:close'));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const target = event.currentTarget;
    if (target.classList.contains('noclose')) return;

    const detailsElement = target.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus?.();
    this.closeAnimation(detailsElement);
  }

  openAnimation() {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        document.body.classList.remove(this.classes.opening);
        document.body.classList.add(this.classes.open);
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        if (detailsElement === this.mainDetailsToggle) {
          document.body.classList.remove(this.classes.closing);
          detailsElement.classList.remove('menu-closing');
        }
        detailsElement.removeAttribute('open');

        if (detailsElement.closest('details[open]')) {
          trapFocus?.(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.closeMenuDrawer(event);
  }
}

customElements.define('menu-drawer', MenuDrawer);


class CartDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'mini-cart--open',
      opening: 'mini-cart--opening',
      closing: 'mini-cart--closing'
    });
  }
}
customElements.define('cart-drawer', CartDrawer);

class FacetDrawer extends MenuDrawer {
  constructor() {
    super();

    if (this.dataset.desktop == 'true') {
      this.setClasses({
        open: 'facet-horizontal--open',
        opening: 'facet-horizontal--opening',
        closing: 'facet-horizontal--closing'
      });
    }
    else {
      this.setClasses({
        open: 'facet-drawer--open',
        opening: 'facet-drawer--opening',
        closing: 'facet-drawer--closing'
      });
    }
  }
}
customElements.define('facet-drawer', FacetDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'menu-mobile--open',
      opening: 'menu-mobile--opening',
      closing: 'menu-mobile--closing'
    });
  }
}
customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
      if (charCode === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    setScrollbarWidth();
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    if (!this.button) return;

    this.button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(this.button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!this.poster) return;
    this.poster.addEventListener('click', this.loadContent.bind(this));
  }
  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      if (content.querySelector('video-section')) {
        const deferredElement = this.appendChild(content);
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          deferredElement.setAttribute('controlslist', 'nodownload');
          deferredElement.play();
        }
      } else {
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO') {
          deferredElement.setAttribute('controlslist', 'nodownload');
          if (deferredElement.getAttribute('autoplay')) {
            // force autoplay for safari
            setTimeout(function () {
              deferredElement.play();
            }, 500);
          }
        }
      }
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

// class SliderComponent extends HTMLElement {
//   constructor() {
//     super();

//     this.slider = this.querySelector('[id^="Slider-"]');
//     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
//     this.enableSliderLooping = false;
//     this.currentPageElement = this.querySelector('.slider-counter--current');
//     this.pageTotalElement = this.querySelector('.slider-counter--total');
//     this.prevButton = this.querySelector('button[name="previous"]');
//     this.nextButton = this.querySelector('button[name="next"]');
//     this.paginationContainer = this.querySelector('.slider-pagination');

//     if (!this.slider) return;

//     theme.initWhenVisible({
//       element: this,
//       callback: this.init.bind(this),
//       threshold: 200
//     });
//   }

//   init() {
//     const resizeObserver = new ResizeObserver(() => this.initPages());
//     resizeObserver.observe(this.slider);

//     this.slider.addEventListener('scroll', this.update.bind(this));

//     if (this.prevButton) {
//       this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
//     }
//     if (this.nextButton) {
//       this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
//     }
//   }

//   initPages() {
//     this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
//     if (this.sliderItemsToShow.length < 2) return;
//     this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
//     this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
//     this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

//     this.renderPaginationDots(); // Ensure dots are always created
//     this.update();
//   }

//   resetPages() {
//     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
//     this.initPages();
//   }

//   renderPaginationDots() {
//     if (!this.paginationContainer) return;

//     this.paginationContainer.innerHTML = ''; // Clear existing dots
//     for (let i = 0; i < this.totalPages; i++) {
//       const dot = document.createElement('button');
//       dot.classList.add('slider-dot');
//       dot.dataset.page = i + 1;
//       dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
//       dot.addEventListener('click', this.onDotClick.bind(this));
//       this.paginationContainer.appendChild(dot);
//     }
//   }

//   update() {
//     const previousPage = this.currentPage;
//     this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

//     if (this.currentPageElement && this.pageTotalElement) {
//       this.currentPageElement.textContent = this.currentPage;
//       this.pageTotalElement.textContent = this.totalPages;
//     }

//     if (this.currentPage !== previousPage) {
//       this.dispatchEvent(
//         new CustomEvent('slideChanged', {
//           detail: {
//             currentPage: this.currentPage,
//             currentElement: this.sliderItemsToShow[this.currentPage - 1],
//           },
//         })
//       );
//     }

//     this.updatePaginationDots();

//     if (this.prevButton || this.nextButton) {
//       // Arrow button visibility logic
//       if (this.currentPage === 1 && this.currentPage === this.totalPages) {
//         this.classList.add('slider--no-buttons');
//       } else {
//         this.classList.remove('slider--no-buttons');
//       }

//       if (this.enableSliderLooping) return;

//       const isFirstSlide = this.currentPage === 1;
//       const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

//       if (this.prevButton) {
//         if (isFirstSlide || this.isSlideVisible(this.sliderItemsToShow[0])) {
//           this.prevButton.setAttribute('disabled', 'disabled');
//         } else {
//           this.prevButton.removeAttribute('disabled');
//         }
//       }

//       if (this.nextButton) {
//         if (isLastSlide || this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
//           this.nextButton.setAttribute('disabled', 'disabled');
//         } else {
//           this.nextButton.removeAttribute('disabled');
//         }
//       }
//     }
//   }

//   updatePaginationDots() {
//     if (!this.paginationContainer) return;

//     const dots = this.paginationContainer.querySelectorAll('.slider-dot');
//     dots.forEach((dot) => dot.classList.remove('active'));
//     const activeDot = this.paginationContainer.querySelector(`.slider-dot[data-page="${this.currentPage}"]`);
//     if (activeDot) activeDot.classList.add('active');
//   }

//   onDotClick(event) {
//     const targetPage = parseInt(event.currentTarget.dataset.page, 10);
//     const targetScrollLeft = (targetPage - 1) * this.sliderItemOffset;

//     this.slider.scrollTo({
//       left: targetScrollLeft,
//       behavior: 'smooth',
//     });
//   }

//   isSlideVisible(element, offset = 0) {
//     const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
//     return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
//   }

//   onButtonClick(event) {
//     event.preventDefault();

//     const step = event.currentTarget.dataset.step || 1;
//     this.slideScrollPosition =
//       event.currentTarget.name === 'next'
//         ? this.slider.scrollLeft + step * this.sliderItemOffset
//         : this.slider.scrollLeft - step * this.sliderItemOffset;
//     this.slider.scrollTo({
//       left: this.slideScrollPosition,
//     });
//   }
// }

// customElements.define('slider-component', SliderComponent);
class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = true; // Enable looping by default
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.paginationContainer = this.querySelector('.slider-pagination');

    if (!this.slider) return;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));

    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.renderPaginationDots();
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  renderPaginationDots() {
    if (!this.paginationContainer) return;

    this.paginationContainer.innerHTML = '';
    for (let i = 0; i < this.totalPages; i++) {
      const dot = document.createElement('button');
      dot.classList.add('slider-dot');
      dot.dataset.page = i + 1;
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', this.onDotClick.bind(this));
      this.paginationContainer.appendChild(dot);
    }
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage !== previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    this.updatePaginationDots();

    if (this.enableSliderLooping) return;

    if (this.prevButton || this.nextButton) {
      if (this.currentPage === 1 && this.currentPage === this.totalPages) {
        this.classList.add('slider--no-buttons');
      } else {
        this.classList.remove('slider--no-buttons');
      }

      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.totalPages;

      if (this.prevButton) {
        if (isFirstSlide) {
          this.prevButton.setAttribute('disabled', 'disabled');
        } else {
          this.prevButton.removeAttribute('disabled');
        }
      }

      if (this.nextButton) {
        if (isLastSlide) {
          this.nextButton.setAttribute('disabled', 'disabled');
        } else {
          this.nextButton.removeAttribute('disabled');
        }
      }
    }
  }

  updatePaginationDots() {
    if (!this.paginationContainer) return;

    const dots = this.paginationContainer.querySelectorAll('.slider-dot');
    dots.forEach((dot) => dot.classList.remove('active'));
    const activeDot = this.paginationContainer.querySelector(`.slider-dot[data-page="${this.currentPage}"]`);
    if (activeDot) activeDot.classList.add('active');
  }

  onDotClick(event) {
    const targetPage = parseInt(event.currentTarget.dataset.page, 10);
    const targetScrollLeft = (targetPage - 1) * this.sliderItemOffset;

    this.slider.scrollTo({
      left: targetScrollLeft,
      behavior: 'smooth',
    });
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();

    if (this.enableSliderLooping) {
      this.handleLoopingNavigation(event);
      return;
    }

    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
      behavior: 'smooth'
    });
  }

  handleLoopingNavigation(event) {
    const isNext = event.currentTarget.name === 'next';
    const lastSlide = this.sliderItemsToShow.length - 1;
    const currentIndex = Math.round(this.slider.scrollLeft / this.sliderItemOffset);

    let targetIndex;

    if (isNext) {
      targetIndex = currentIndex >= lastSlide ? 0 : currentIndex + 1;
    } else {
      targetIndex = currentIndex <= 0 ? lastSlide : currentIndex - 1;
    }

    this.slider.scrollTo({
      left: targetIndex * this.sliderItemOffset,
      behavior: 'smooth'
    });
  }
}

customElements.define('slider-component', SliderComponent);


class ThumbnailSlider extends SliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();

    const variantItems = this.querySelectorAll('.thumbnail-list_item--variant:not(.is-active)');
    this.slider.dataset.mediaCount = this.sliderItems.length - variantItems.length;

    if (this.querySelector('[data-gang-option]')) {
      const inactiveGangItems = this.querySelectorAll('[data-gang-option]:not(.gang__active)');
      this.slider.dataset.mediaCount = this.sliderItems.length - inactiveGangItems.length;
    }

    // if (this.slider.dataset.mediaCount < 2) this.classList.add('hidden');
  }
}
customElements.define('thumbnail-slider', ThumbnailSlider);

class QuoteSlider extends SliderComponent {
  constructor() {
    super();
  }

  update() {
    super.update();

    if (this.currentPageElement && this.pageTotalElement) {
      this.sliderItems.forEach((element) => {
        element.removeAttribute('aria-current');
      });

      const currentElement = this.sliderItemsToShow[this.currentPage - 1];
      currentElement.setAttribute('aria-current', true);
    }
  }
}
customElements.define('quote-slider', QuoteSlider);

class ProductGallery extends SliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();

    const gallerySliderButtons = this.querySelector('.slider-buttons');
    if (gallerySliderButtons && this.querySelector('[data-gang-option]')) {
      if (this.querySelectorAll('.product__media-item.gang__active').length < 2) {
        gallerySliderButtons.classList.add('hidden');
      } else {
        gallerySliderButtons.classList.remove('hidden');
      }
    }

    this.cursor = this.querySelector('.gallery-cursor');
    if (!this.cursor) return;

    const images = this.querySelectorAll('.product__modal-opener--image');
    images.forEach((image) => image.addEventListener('mousemove', this.onMoveHandler.bind(this)));
    images.forEach((image) => image.addEventListener('mouseenter', this.onEnterHandler.bind(this)));
    images.forEach((image) => image.addEventListener('mouseleave', this.onLeaveHandler.bind(this)));
  }

  onMoveHandler(event) {
    this.cursor.style.left = `${event.clientX - 32}px`;
    this.cursor.style.top = `${event.clientY - 32}px`;
  }

  onEnterHandler() {
    this.cursor.classList.add('show');
  }

  onLeaveHandler() {
    this.cursor.classList.remove('show');
  }

  update() {
    super.update();

    if (this.currentPageElement && this.pageTotalElement) {
      const currentElement = this.sliderItemsToShow[this.currentPage - 1];
      if (currentElement) {
        this.slider.style.setProperty('--force-image-ratio-percent', currentElement.querySelector('.media').style.getPropertyValue('--image-ratio-percent'));
      }
    }
  }

  goToFirstSlide() {
    this.slider.scrollTo({
      left: 0
    });
  }
}
customElements.define('product-gallery', ProductGallery);




class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', this.onVariantChange);

    this.updateOptions();
    this.updateMasterId();
    this.setAvailability();
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.validateGang();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.setAvailabilityInUnavailable();
    } else {
      if (this.gangOption) {
        this.updateGangMedia();
      } else {
        this.updateMedia();
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.setAvailability();

      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
          variant: this.currentVariant
        }
      }));
    }

    this.handleStickyCart(event.target);
    handleVariantUpdate(this.currentVariant);
  }

  handleStickyCart(target) {
    const stickyCart = document.getElementById(`sticky-cart-${this.dataset.section}`);
    if (!stickyCart) return;

    const attribute = target.getAttribute('name');

    document.querySelectorAll(`variant-radios[data-section="${this.dataset.section}"] [name="${attribute}"], variant-selects[data-section="${this.dataset.section}"] [name="${attribute}"]`)
      .forEach((input) => {
        if (input.tagName === 'INPUT') {
          input.checked = input.value === target.value;
        }
        else {
          input.value = target.value;
        }
      });

    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const image = document.querySelector('.sticky-cart__content-image img');
    if (image) {
      image.srcset = `${this.currentVariant.featured_media.preview_image.src}&width=70 1x, ${this.currentVariant.featured_media.preview_image.src}&width=140 2x`;
      image.src = `${this.currentVariant.featured_media.preview_image.src}&width=70`;
      image.width = 70;
      image.height = Math.ceil(70 / this.currentVariant.featured_media.preview_image.aspect_ratio);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData()?.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  validateGang() {
    const mediaItemWithGang = document.querySelector(`#shopify-section-${this.dataset.section} [data-gang-option], quick-view-drawer details[open] [data-gang-option]`);
    if (mediaItemWithGang) {
      this.gangOption = mediaItemWithGang.dataset.gangOption;
    }
  }

  updateGangMedia() {
    if (!this.gangOption) return;

    const variantInputWrapper = this.querySelector('.variant-input-wrapper[data-option-slug="' + this.gangOption + '"]');
    if (variantInputWrapper) {
      this.gangIndex = variantInputWrapper.dataset.optionIndex;
    } else {
      this.gangOption = null;
    }

    if (!this.currentVariant) return;
    //if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    const gangValue = this.getSlug(this.currentVariant[this.gangIndex]);
    if (this.currentGangValue !== gangValue) {
      document.querySelectorAll(
        `#shopify-section-${this.dataset.section} [data-gang-connect], quick-view-drawer details[open] [data-gang-connect]`
      ).forEach(function (media) {
        media.classList.remove('gang__active');
      });

      this.currentGangValue = gangValue;
      var gangConnect = this.gangOption + '_' + gangValue;
      const newMedias = document.querySelectorAll(
        `#shopify-section-${this.dataset.section} [data-gang-connect="${gangConnect}"], quick-view-drawer details[open] [data-gang-connect="${gangConnect}"]`
      );

      if (!newMedias.length) return;
      Array.from(newMedias).reverse().forEach(function (newMedia, idx) {
        if (!newMedia.classList.contains('images-with-text__image')) {
          newMedia.classList.add('gang__active');
        } else {
          if (idx < 5) newMedia.classList.add('gang__active');
        }
        let parent = newMedia.parentElement;
        if (parent.firstChild != newMedia) {
          parent.prepend(newMedia);
          parent.classList.add('product__media-no-animate');
        }
      });

      const thumbnailSlider = document.getElementById(`GalleryThumbnails-${this.dataset.section}`);
      if (thumbnailSlider) {
        const inactiveItems = thumbnailSlider.querySelectorAll('.thumbnail-list__item:not(.gang__active)');
        thumbnailSlider.slider.dataset.mediaCount = thumbnailSlider.sliderItems.length - inactiveItems.length;
        if (thumbnailSlider.slider.dataset.mediaCount < 2) {
          thumbnailSlider.classList.add('hidden');
        } else {
          thumbnailSlider.classList.remove('hidden');
        }
        thumbnailSlider.resetPages();
      }

      if (!mediaGallery) {
        const productGallery = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery, quick-view-drawer details[open] product-gallery`)
        if (productGallery) {
          productGallery.resetPages();
          productGallery.goToFirstSlide();
        }
      }

      const gallerySliderButtons = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery .slider-buttons, quick-view-drawer details[open] product-gallery .slider-buttons`);
      if (gallerySliderButtons) {
        if (document.querySelectorAll(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`).length < 2) {
          gallerySliderButtons.classList.add('hidden');
        } else {
          gallerySliderButtons.classList.remove('hidden');
        }
      }
    }

    if (!this.currentVariant.featured_media) {
      if (!document.querySelectorAll(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active.is-active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active.is-active`).length) {
        document.querySelector(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`).classList.add('is-active');
      }
      return;
    }

    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === 'undefined';
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, scrollIntoView);
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }

    const thumbnailContent = document.querySelector(`#ProductThumbnails-${this.dataset.section}`);
    if (thumbnailContent) {
      const newMediaThumbnail = thumbnailContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      thumbnailContent.prepend(newMediaThumbnail);
    }
  }

  CJKDetect(someString) {
    // Korean
    if (someString.search("[\uac00-\ud7a3]") >= 0) return "ko";
    // Japanese
    if (someString.search("[\u3040-\u30ff]") >= 0) return "ja";
    // Chinese
    if (someString.search("[\u4e00-\u9FFF]") >= 0) return "zh";

    return "none";
  }

  getSlug(someString) {
    if (this.CJKDetect(someString) != "none") return someString;
    return someString.toString().replace('ı', 'i').replace('ß', 'ss').normalize('NFD').replace('-', ' ').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, "-");
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
    const newMedia = document.querySelector(`[data-media-id="${mediaId}"]`);

    if (!newMedia) return;

    // Move image to first if not already
    const parent = newMedia.parentElement;
    if (parent.firstChild !== newMedia) {
      parent.prepend(newMedia);
      parent.classList.add('product__media-no-animate');
    }

    // Always reset and scroll
    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === 'undefined';
      mediaGallery.setActiveMedia(mediaId, true, scrollIntoView);
      mediaGallery.resetPages?.(); // defensive call
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const thumbnailContent = document.querySelector(`#ProductThumbnails-${this.dataset.section}`);

    if (modalContent) {
      const modalMedia = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      if (modalMedia && modalContent.firstChild !== modalMedia) {
        modalContent.prepend(modalMedia);
      }
    }

    if (thumbnailContent) {
      const thumbMedia = thumbnailContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      if (thumbMedia && thumbnailContent.firstChild !== thumbMedia) {
        thumbnailContent.prepend(thumbMedia);
      }
    }

    // Go to first slide on product gallery
    const productGallery = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery`);
    if (productGallery?.goToFirstSlide) {
      productGallery.resetPages?.();
      productGallery.goToFirstSlide();
    }
  }


  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}--alt`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      const skuInput = productForm.querySelector('input[name="sku"]');
      if (skuInput) {
        skuInput.value = this.currentVariant.sku;
        skuInput.dispatchEvent(new Event('change', { bubbles: true }));

      }

    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        this.updateSKU(responseText);
        this.updatePrice(responseText);
        this.updatePriceAlt(responseText);
        this.updateColorName(responseText);
        this.updateInventoryStatus(responseText);
        this.updateSellingPrice(responseText);
        this.updateSaveLabel(responseText);
        this.updateSellingSaveLabel(responseText);
        this.updateSellingOriginaliPrice(responseText);
        if (this.currentVariant) this.toggleAddButton(!this.currentVariant.available, theme.variantStrings.soldOut);
        this.updateCustomLiquid(responseText);

        document.dispatchEvent(new CustomEvent('productInfo:loaded'));

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            variant: this.currentVariant,
          },
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  updateSKU(responseText) {
    const id = `sku-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }



  updateCustomLiquid(responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destinations = document.querySelectorAll(`.custom__liquid-${this.dataset.section}`);
    const sources = html.querySelectorAll(`.custom__liquid-${this.dataset.section}`);

    for (let i = 0, clLength = destinations.length; i < clLength; i++) {
      destinations[i].innerHTML = sources[i].innerHTML;
    }
  }

  updatePrice(responseText) {
    const id = `price-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }


  updateSellingPrice(responseText) {
    //  console.log('update price calles')
    const id = `selling-plan-price-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updateSaveLabel(responseText) {
    const id = `save-label-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) {

      const sourceContent = source.innerHTML.trim();
      if (sourceContent) {
        destination.innerHTML = sourceContent;
        destination.style.display = 'inline';
      } else {
        destination.style.display = 'none';
      }
    } else if (destination) {
      destination.style.display = 'none';
    }

    console.log('source:', source);
  }


  updateSellingSaveLabel(responseText) {
    const id = `selling-save-label-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);
    if (source && destination) {

      const sourceContent = source.innerHTML.trim();
      if (sourceContent) {
        destination.innerHTML = sourceContent;
        destination.style.display = 'inline';
      } else {
        destination.style.display = 'none';
      }
    } else if (destination) {
      destination.style.display = 'none';
    }
    console.log('updateSellingSaveLabel(responseText)', source)
  }
  updateSellingOriginaliPrice(responseText) {
    // console.log('updateSellingOriginaliPrice')
    const id = `selling-original-price-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updatePriceAlt(responseText) {
    const id = `price-${this.dataset.section}--alt`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updateColorName(responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    for (let index = 1; index <= 3; index++) {
      const id = index > 1 ? `color-${this.dataset.section}-${index}` : `color-${this.dataset.section}`;
      const destination = document.getElementById(id);
      const source = html.getElementById(id);

      if (source && destination) destination.innerHTML = source.innerHTML;
      if (destination) destination.classList.remove('visibility-hidden');
    }
  }

  updateInventoryStatus(responseText) {
    const id = `inventory-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`);
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', true);
        if (text) addButton.textContent = text;
      }
      else {
        addButton.removeAttribute('disabled');
        addButton.textContent = addButton.dataset.preOrder === 'true' ? theme.variantStrings.preOrder : theme.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    });
  }

  setUnavailable() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`);
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.textContent = theme.variantStrings.unavailable;

      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.add('visibility-hidden');

      const priceAlt = document.getElementById(`price-${this.dataset.section}--alt`);
      if (priceAlt) priceAlt.classList.add('visibility-hidden');

      const inventory = document.getElementById(`inventory-${this.dataset.section}`);
      if (inventory) inventory.classList.add('visibility-hidden');
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  setAvailability() {
    if (!this.currentVariant) return;

    this.querySelectorAll('.variant-input-wrapper').forEach(group => {
      this.disableVariantGroup(group);
    });

    const currentlySelectedValues = this.currentVariant.options.map((value, index) => { return { value, index: `option${index + 1}` } })
    const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant);

    for (var [option, values] of Object.entries(initialOptions)) {
      this.manageOptionState(option, values);
    }
  }

  setAvailabilityInUnavailable() {
    this.querySelectorAll('.variant-input-wrapper').forEach(group => {
      this.disableVariantGroup(group);
    });

    const currentlySelectedValues = this.options.map((value, index) => { return { value, index: `option${index + 1}` } })
    const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant);

    for (var [option, values] of Object.entries(initialOptions)) {
      this.manageOptionState(option, values);
    }
  }

  enableVariantOption(group, obj) {
    const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
    group.querySelector('option[value="' + value + '"]').disabled = false;
  }

  disableVariantGroup(group) {
    group.querySelectorAll('option').forEach((option) => {
      option.disabled = true;
    });
  }

  manageOptionState(option, values) {
    const group = this.querySelector('.variant-input-wrapper[data-option-index="' + option + '"]');

    // Loop through each option value
    values.forEach(obj => {
      this.enableVariantOption(group, obj);
    });
  }

  createAvailableOptionsTree(variants, currentlySelectedValues) {
    // Reduce variant array into option availability tree
    return variants.reduce((options, variant) => {

      // Check each option group (e.g. option1, option2, option3) of the variant
      Object.keys(options).forEach(index => {

        if (variant[index] === null) return;

        let entry = options[index].find(option => option.value === variant[index]);

        if (typeof entry === 'undefined') {
          // If option has yet to be added to the options tree, add it
          entry = { value: variant[index], soldOut: true }
          options[index].push(entry);
        }

        const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1')
        const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2')

        switch (index) {
          case 'option1':
            // Option1 inputs should always remain enabled based on all available variants
            entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            break;
          case 'option2':
            // Option2 inputs should remain enabled based on available variants that match first option group
            if (currentOption1 && variant['option1'] === currentOption1.value) {
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            }
          case 'option3':
            // Option 3 inputs should remain enabled based on available variants that match first and second option group
            if (
              currentOption1 && variant['option1'] === currentOption1.value
              && currentOption2 && variant['option2'] === currentOption2.value
            ) {
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            }
        }
      })

      return options;
    }, { option1: [], option2: [], option3: [] })
  }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  enableVariantOption(group, obj) {
    const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
    const input = group.querySelector('input[data-option-value="' + value + '"]');

    // Variant exists - enable & show variant
    input.removeAttribute('disabled');
    input.removeAttribute('data-crossout');

    // Variant sold out - cross out option (remains selectable)
    if (obj.soldOut) {
      if (this.hasAttribute('data-swatch-cross')) {
        if (this.hasAttribute('data-swatch-oos-click')) {
          input.setAttribute('data-crossout', '');
        }
        // customisation since behavior update to keep radio enable
        // else {
        // input.setAttribute('disabled', '');
        //}
      }
    }
  }

  disableVariantGroup(group) {
    group.querySelectorAll('input').forEach((input) => {
      input.setAttribute('disabled', '');
    });
  }
}
customElements.define('variant-radios', VariantRadios);

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.miniCart = document.querySelector('mini-cart');
    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.hideErrors = this.dataset.hideErrors === 'true';
  }

  onSubmitHandler(evt) {
    if (document.body.classList.contains('template-cart') || !window.shopSettings.cartDrawer) {
      return;
    }

    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton.classList.contains('loading')) {
      return;
    }
    this.handleErrorMessage();
    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');

    // Set up config if needed
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    const sections = this.miniCart ? this.miniCart.getSectionsToRender().map(section => section.id) : [];
    formData.append('sections_url', window.location.pathname);

    // Get discount settings
    const discountRule = window.discount.discount_rule;
    const enableDiscount = window.discount.enableDiscount;
    const anyProduct = window.discount.anyProduct;
    const prerequisiteSKUs = window.discount.skus;
    const free_gift_new = window.min_gift.free_git_new;
    const free_gift = window.min_gift.free_git;
    const enabled_gwp1 = window.min_gift.enabled_gwp1;
    const enabled_gwp2 = window.min_gift.enabled_gwp2;

    // console.log(discountRule, "discountRule");
    // console.log(enableDiscount, "enableDiscount");
    // console.log(anyProduct, "anyProduct");
    // console.log(prerequisiteSKUs, "prerequisiteSKUs");

    // Get quantity from formData
    const qty = parseInt(formData.get('quantity')) || 1;
    // console.log('Parsed Quantity:', qty);

    const currentSKU = formData.get('sku');
    const isValidSKU = prerequisiteSKUs.includes(currentSKU);
    // console.log("Current SKU:", currentSKU, "Valid?", isValidSKU);

    const productId = parseInt(formData.get('id'));
    const actualProductId = parseInt(this.dataset.productId);

    const _this = this;
    const sellingPlanValue = parseInt(formData.get('selling_plan')) || '';

    // First, fetch the current cart to check for an existing product
    fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        document.dispatchEvent(new CustomEvent("cart:updated", {
          detail: { cart: cartData }
        }));

        const settingLimit = parseInt(window.max_limits?.max_limit) || 0;
        const submitButton = this.querySelector('[type="submit"]');

        if (settingLimit > 0) {
          let existingItem = cartData.items.find(item => {
            const itemSellingPlan = item.selling_plan ? parseInt(item.selling_plan) : '';
            return item.id === productId && itemSellingPlan === sellingPlanValue;
          });

          let totalQty = qty;
          if (existingItem) {
            totalQty += existingItem.quantity;
          }

          if (totalQty > settingLimit) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.handleErrorMessage(`You can only add ${settingLimit} of this item to your cart`);
            return;
          }
        }

        // Try to find an existing item in the cart.
        let existingItem = cartData.items.find(item => {
          const itemSellingPlan = item.selling_plan ? parseInt(item.selling_plan) : '';
          const isGift = item.properties?._min_gift_product === true
            || item.properties?._min_gift_product_new === true
            || item.properties?._campaign_type === 'auto_gwp_1'
            || item.properties?._campaign_type === 'auto_gwp_2'
            || item.properties?._campaign_type === 'manual_gwp';
          return item.id === productId && itemSellingPlan === sellingPlanValue && !isGift;
        });

        let totalQty = qty;
        if (existingItem) {
          totalQty += existingItem.quantity;
        }

        // console.log(totalQty, "totalQty");
        // console.log(existingItem, "existingItem");

        // Get all items with valid SKUs from the cart
        const totalCartQuantity = cartData.items.reduce((sum, item) => {
          if (item.id !== free_gift && item.id !== free_gift_new) {
            return sum + item.quantity;
          }
          return sum;
        }, 0);

        const newCartQuantity = totalCartQuantity + qty;

        // console.log(newCartQuantity, "newCartQuantity ");



        const validSKUProduct = cartData.items.filter(item => prerequisiteSKUs.includes(item.sku));
        console.log(validSKUProduct, "validSKUProduct");

        let validSKUQty = qty;
        validSKUProduct.forEach(item => {
          validSKUQty += Number(item.quantity); // Explicitly convert to number
        });


        // Determine the matching discount rule based on total quantity.
        const discountRulesArray = discountRule.split(',');
        let matchedRule = "";
        let quantityToUse = anyProduct ? newCartQuantity : validSKUQty;
        // console.log(quantityToUse, "quantityToUse");

        // Look for an exact match first.
        discountRulesArray.forEach(rule => {
          let parts = rule.split('for'); // e.g., "3for45" becomes ["3", "45"]
          if (parseInt(parts[0], 10) === quantityToUse) {
            matchedRule = rule;
          }
        });
        // If no exact match, then find the closest rule.
        if (!matchedRule) {
          const lastRule = discountRulesArray[discountRulesArray.length - 1];
          let closestRule = null;
          for (let rule of discountRulesArray) {
            let ruleQty = parseInt(rule.split('for')[0], 10);
            if (ruleQty <= quantityToUse) {
              closestRule = rule;
            } else {
              break;
            }
          }
          matchedRule = closestRule || lastRule;
        }
        // console.log('Matched Discount Rule:', matchedRule);

        // Determine the dynamic property—if discount is enabled.
        let dynamicprop = {};
        if (enableDiscount && !enabled_gwp1 && !enabled_gwp2) {
          if (anyProduct) {
            dynamicprop = { "_dynamic_val": matchedRule };
          } else {
            const sku = formData.get('sku');
            if (prerequisiteSKUs.includes(sku)) {
              dynamicprop = { "_dynamic_val": matchedRule };
            }
          }
        }

        const actualProductId = parseInt(this.dataset.productId); // get actual product ID
        const distRate = window.dist_rate || {};

        // Extract enable flags
        const isEnabled1 = distRate.enable_discount_rate === true || distRate.enable_discount_rate === 'true';
        const isEnabled2 = distRate.enable_discount_rate2 === true || distRate.enable_discount_rate2 === 'true';

        // Extract discount fields and their product ID sets
        const discountRate1 = parseFloat(distRate.dist_per);
        const hasRate1 = isEnabled1 && !isNaN(discountRate1);
        const productIds1 = hasRate1 ? (distRate.dist_product || "").split(',').map(id => id.trim()).filter(Boolean) : [];

        const discountRate2 = parseFloat(distRate.dist_per2);
        const hasRate2 = isEnabled2 && !isNaN(discountRate2);
        const productIds2 = hasRate2 ? (distRate.dist_product2 || "").split(',').map(id => id.trim()).filter(Boolean) : [];

        // Determine applicable discount
        let finalDiscount = null;

        if (
          hasRate1 &&
          (productIds1.length === 0 || productIds1.includes(actualProductId.toString()))
        ) {
          finalDiscount = discountRate1;
        }

        if (
          finalDiscount === null &&
          hasRate2 &&
          (productIds2.length === 0 || productIds2.includes(actualProductId.toString()))
        ) {
          finalDiscount = discountRate2;
        }

        // Fallback if both lists are empty and rate1 is valid
        if (
          finalDiscount === null &&
          hasRate1 &&
          productIds1.length === 0 &&
          (!hasRate2 || productIds2.length === 0)
        ) {
          finalDiscount = discountRate1;
        }

        // Apply discount if determined
        const enableTierDiscount = window.TierDiscount?.enableTierDiscount === true;
        // console.log(enableTierDiscount, "enableTierDiscount");

        if (enableTierDiscount) {
          dynamicprop["_tiered_discount_minspend"] = "yes";
        }
        else if (finalDiscount !== null) {
          dynamicprop["_discount_rate"] = finalDiscount;
        }
        // Build the items array.
        let items = [
          {
            quantity: totalQty,
            id: productId,
            selling_plan: sellingPlanValue,
            properties: dynamicprop
          }
        ];
        console.log('Final Items:', items);

        // Choose the endpoint.
        let endpoint, payload;
        if (existingItem && !enableTierDiscount) {
          endpoint = window.routes.cart_change_url;
          // Derive the line number by finding the index in the cart and adding 1.
          const lineNumber = cartData.items.findIndex(item => item.key === existingItem.key) + 1;
          payload = {
            line: lineNumber,
            quantity: totalQty,
            properties: dynamicprop,
            sections: sections,
            sections_url: window.location.pathname
          };
        } else {
          endpoint = window.routes.cart_add_url;
          payload = {
            items: items,
            sections: sections,
            sections_url: window.location.pathname
          };
        }
        const url = endpoint + '.js';

        // Call the appropriate endpoint.
        fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify(payload)
        })
          .then(response => response.json())
          .then(response => {
            const Main_response = response;
            // Fetch the updated cart.
            fetch(`${window.routes.cart_url}.js`)
              .then(response => response.json())
              .then(updatedCartData => {
                // Immediately update UI so mini-cart popup can show without waiting
                changeContent(_this, Main_response);
                const free_gift = window.min_gift.free_git;
                const minPrice = window.min_gift.min_price;
                const campaign_name = window.min_gift.campaign_name;
                const isGiftAdded = updatedCartData.items.some(item => item.id == free_gift && item.properties?._min_gift_product === true );
                const free_gift_new = window.min_gift.free_git_new;
                const minPriceNew = window.min_gift.min_price_new;
                const campaign_name_new = window.min_gift.campaign_name_new;
                const isGiftAddedNew = updatedCartData.items.some(item => item.id == free_gift_new && item.properties?._min_gift_product_new === true );
                const enabled_gwp1 = window.min_gift.enabled_gwp1;
                const enabled_gwp2 = window.min_gift.enabled_gwp2;

                // variant id based
                const pr_gift = window.prod_gift.pr_gift;
                const enabled_prod_gift = window.prod_gift.enabled_prod_gift;
                const allowedVariants = window.prod_gift.variant_ids;

                // Does the cart contain one of the required variants?
                const hasRequiredVariant = updatedCartData.items.some(item =>
                  allowedVariants.includes(item.id.toString())
                );

                // Is the variant gift already in the cart?
                const isVariantGiftAdded = updatedCartData.items.some(item => item.id == pr_gift);

                if (enabled_prod_gift && hasRequiredVariant) {
                  addFreeGift(pr_gift, isVariantGiftAdded, 0, 0, "auto_gwp_2", "", "_min_gift_product_new", updatedCartData, enabled_prod_gift
                  );
                } else {
                  removeFreeGift("_min_gift_product_new", updatedCartData);
                }

                const cartTotalExcludingGiftCard = updatedCartData.items
                  .filter(item =>
                    item.handle !== "gift-card" &&               // exclude gift-card
                    item.properties?._campaign_type !== "auto_gwp_1" &&   // exclude auto GWP
                    item.properties?._min_gift_product !== true    &&          // exclude minimum gift product
                    item.properties?._campaign_type !== "auto_gwp_2" &&
                    item.properties?._min_gift_product_new !== true        // exclude minimum gift product
                  )
                  .reduce((total, item) => total + item.original_line_price, 0);

                  console.log(enabled_gwp2,"enabled_gwp2");
                  console.log(enabled_gwp1,"enabled_gwp1");

                 
                     
               async function handleBothGwps() {
                 if (!window.b3g1_config.enabled){
                if (enabled_gwp1) {
                  await addFreeGift(
                    free_gift,
                    isGiftAdded,
                    minPrice,
                    cartTotalExcludingGiftCard,
                    "auto_gwp_1",
                    campaign_name,
                    "_min_gift_product",
                    cartData,
                    enabled_gwp1
                  );
                }

                if (!enabled_prod_gift && enabled_gwp2) {
                  // Use already-fetched updatedCartData to avoid extra network calls
                  const updatedCart = updatedCartData;
                  const isGiftAddedNewFresh = updatedCart.items.some(item =>
                    item.id == free_gift_new &&
                    item.properties?._campaign_type === "auto_gwp_2"
                  );

                  await addFreeGift(
                    free_gift_new,
                    isGiftAddedNewFresh,
                    minPriceNew,
                    cartTotalExcludingGiftCard,
                    "auto_gwp_2",
                    campaign_name_new,
                    "_min_gift_product_new",
                    updatedCart,
                    enabled_gwp2
                  );
                }
              }

                // B3G1 Logic
                if (window.b3g1_config && window.b3g1_config.enabled) {
                  const b3g1Config = window.b3g1_config;
                  const b3g1Exclude = b3g1Config.exclude_ids || [];
                  
                  // Use updatedCartData instead of refetching
                  const currentCart = updatedCartData;
                  
                  const b3g1Count = currentCart.items.reduce((total, item) => {
                    if (item.properties && (
                      item.properties._campaign_type || 
                      item.properties._min_gift_product || 
                      item.properties._min_gift_product_new ||
                      item.properties._b3g1_gift
                    )) return total;
                    if (b3g1Exclude.includes(item.product_id.toString()) || b3g1Exclude.includes(item.variant_id.toString())) return total;
                    return total + item.quantity;
                  }, 0);

                  const giftId = b3g1Config.gift_variant_id;
                  const isB3G1Added = currentCart.items.find(item => item.id == giftId && item.properties?._campaign_type === b3g1Config.campaign_type);

                  if (b3g1Count >= (b3g1Config.required_qty || 3)) {
                    if (!isB3G1Added && giftId != 0) {
                      const props = {
                        "_campaign_type": b3g1Config.campaign_type,
                        "_campaign_name": b3g1Config.campaign_name,
                        "_discount_quantity": "1",
                        "_b3g1_gift": true
                      };
                      await fetch(`${window.routes.cart_add_url}.js`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' },
                        body: JSON.stringify({ items: [{ id: parseInt(giftId), quantity: 1, properties: props }], sections, sections_url: window.location.pathname })
                      })
                      .then(r => r.json())
                      .then(r => changeContent(_this, r));
                    }
                  } else {
                    if (isB3G1Added) {
                      await fetch(`${window.routes.cart_change_url}.js`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' },
                        body: JSON.stringify({ id: isB3G1Added.key, quantity: 0, sections, sections_url: window.location.pathname })
                      })
                      .then(r => r.json())
                      .then(r => changeContent(_this, r));
                    }
                  }
                  // If no gift add/remove happened, UI has already been updated via Main_response
                }
              }

              // Trigger gift logic without blocking UI update
              handleBothGwps();

                // --- Free Gift Helper Functions ---
                function addFreeGift(freeGiftId, isGiftAdded, minPrice, cartTotal, campaignType, campaignName, giftProperty, cartData, enabledGwp) {
                  if (cartTotal >= minPrice && freeGiftId != 0 && minPrice >= 0 && enabledGwp) {
                    if (!isGiftAdded) {
                      const props = {
                        "_campaign_type": campaignType,
                        "_discount_quantity": "1",
                        "_campaign_name": campaignName,
                        [giftProperty]: true
                      };
                      const items = [{ quantity: 1, id: parseInt(freeGiftId), properties: props }];
                      console.log(`Adding free gift (${campaignType}):`, items);
                      fetch(`${window.routes.cart_add_url}.js`, {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                          'Content-Type': 'application/json',
                          'X-Requested-With': 'xmlhttprequest'
                        },
                        body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
                      })
                        .then(response => response.json())
                        .then(response => {
                          console.log(`Free gift response (${campaignType}):`, response);
                          changeContent(_this, response);
                        });
                    } else {
                      changeContent(_this, Main_response);
                    }
                  } else {
                    removeFreeGift(giftProperty, cartData);
                  }
                }

                function removeFreeGift(giftProperty, cartData) {
                  const giftItems = cartData.items.filter(item => item.properties?.[giftProperty] === true);
                  if (giftItems.length) {
                    const removalRequests = giftItems.map(giftItem => {
                      return fetch(`${window.routes.cart_change_url}.js`, {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                          'Content-Type': 'application/json',
                          'X-Requested-With': 'xmlhttprequest'
                        },
                        body: JSON.stringify({ id: giftItem.key, quantity: 0, sections, sections_url: window.location.pathname })
                      }).then(response => response.json());
                    });
                    Promise.all(removalRequests).then(responses => {
                      console.log("Gift removal responses:", responses);
                      changeContent(_this, responses[responses.length - 1]);
                    });
                  } else {
                    changeContent(_this, Main_response);
                  }
                }

                function changeContent(_this, response) {
                  if (response.status) {
                    console.error("Cart error:", response.errors || response.description);
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      errors: response.errors || response.description,
                      message: response.message,
                    });
                    _this.handleErrorMessage(response.description);
                    _this.error = true;
                    return;
                  }
                  if (!_this.error) {
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
                  }
                  _this.error = false;
                  if (_this.miniCart) {
                    _this.miniCart.renderContents(response);
                  }
                }

                if (!enabled_gwp1 && !enabled_gwp2) {
                  // Apply discount updates to valid SKU items if discount is enabled and not for anyProduct.
                  if (enableDiscount && !anyProduct && matchedRule !== "") {
                    const validSKUItems = updatedCartData.items.filter(item => prerequisiteSKUs.includes(item.sku));
                    updateValidSKUItems(validSKUItems, matchedRule, sections, updatedCartData);
                  } else if (enableDiscount) {
                    const validSKUItems = updatedCartData.items.filter(item => item.id !== free_gift && item.id !== free_gift_new);
                    updateValidSKUItems(validSKUItems, matchedRule, sections, updatedCartData);
                  }
                }
                // --- Chained update function ---
                async function updateValidSKUItems(validSKUItems, discountRule, sections, cartData) {
                  console.log('Starting chain update with discount rule:', discountRule);
                  for (const item of validSKUItems) {
                    // Derive the line number for this item.
                    const lineNumber = cartData.items.findIndex(i => i.key === item.key) + 1;
                    const payload = {
                      line: lineNumber,
                      quantity: item.quantity,
                      properties: {
                        ...item.properties,
                        _dynamic_val: discountRule,
                        _update_id: Date.now() // Optional unique identifier
                      },
                      sections: sections,
                      sections_url: window.location.pathname
                    };
                    console.log(`Updating SKU: ${item.sku}, Payload:`, payload);
                    try {
                      const response = await fetch(`${window.routes.cart_change_url}.js`, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                          'X-Requested-With': 'xmlhttprequest'
                        },
                        body: JSON.stringify(payload)
                      });
                      const data = await response.json();
                      console.log(`Update response for ${item.sku}:`, data);
                    } catch (error) {
                      console.error(`Error updating ${item.sku}:`, error);
                    }
                    // Delay slightly before the next request.
                    await new Promise(resolve => setTimeout(resolve, 100));
                  }
                }

              });
          })
          .catch(e => {
            console.error("Fetch error:", e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (this.errorMessageWrapper) {
      if (this.hideErrors) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        console.error("Error message:", errorMessage);
        this.errorMessage.textContent = errorMessage;
      }
    } else {
      if (errorMessage) {
        console.error("Alert error message:", errorMessage);
        alert(errorMessage);
      }
    }
  }
}
customElements.define('product-form', ProductForm);



class ProgressBar extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    setTimeout(() => {
      const quantity = parseInt(this.dataset.quantity);
      this.style.setProperty('--progress-bar-width', `${quantity * 100 / 30}%`);
    }, 1e3);
  }
}
customElements.define('progress-bar', ProgressBar);

class FormState extends HTMLElement {
  constructor() {
    super();

    this.formInputs = this.querySelectorAll('input,select,textarea');
    this.form = this.querySelector('form');

    this.formInputs.forEach((input) => {
      input.addEventListener('input', this.onInputChange.bind(this));
      input.addEventListener('blur', this.onInputChange.bind(this));
    });

    if (this.form) this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  onInputChange(event) {
    this.handleInputCheck(event.target);
  }

  onSubmitHandler(event) {
    let valid = !0;

    this.formInputs.forEach((input) => {
      if (!this.handleInputCheck(input)) {
        valid = !1;
      }
    });

    if (!valid) {
      event.preventDefault();
      return;
    }
  }

  handleInputCheck(input) {
    if (input.classList.contains('required')) {

      if (input.value.length === 0 || input.value === input.dataset.empty) {
        input.classList.remove('valid');
        input.classList.add('invalid');

        return !1;
      }
      else {
        input.classList.remove('invalid');
        input.classList.add('valid');

        return !0;
      }
    }

    return !0;
  }
}
customElements.define('form-state', FormState);

class ListMenuItem extends HTMLElement {
  constructor() {
    super();

    this.listMenuHover = this.closest('menu-drawer').querySelector('list-menu-hover');

    this.addEventListener('mouseenter', () => {
      this.listMenuHover.open({
        title: this.dataset.title,
        url: this.dataset.url,
        image: this.dataset.image,
        description: this.dataset.description
      });
    });
  }
}
customElements.define('list-menu-item', ListMenuItem);

class ListMenuHover extends HTMLElement {
  constructor() {
    super();
  }

  open(obj) {
    let html = '';
    const opened = obj.image.length > 0 || obj.description.length > 0;

    if (opened) {
      html += `<a href="${obj.url}" class="hover-collection${obj.image.length > 0 ? '' : ' hover-collection--no-image'}">`;
      html += '<figure class="hover-collection__image"' + (obj.image.length > 0 ? `style="background-image:url(${obj.image})"` : '') + '></figure>';
      html += '<div class="hover-collection__content">'
      html += `<span class="hover-collection__title h4">${obj.title}</span>`;
      html += obj.description.length > 0 ? `<div class="hover-collection__description">${obj.description}</div>` : '';
      html += '</div>';
      html += '</a>';
    }

    this.innerHTML = html;
  }

  close() {
    this.innerHTML = '';
  }
}
customElements.define('list-menu-hover', ListMenuHover);

class TransparentHeader extends HTMLElement {
  constructor() {
    super();

    const header = document.querySelector('.shopify-section-header');

    header.classList.add('transparent-header');
    if (this.dataset.showSeparator == 'true') {
      header.classList.add('transparent-separator');
    }
  }
}
customElements.define('transparent-header', TransparentHeader);


function getTotalQuantityForVariant(variantId) {
  return fetch(`${window.routes.cart_url}.js`)
    .then(response => response.json())
    .then(cartData => {
      let totalQty = cartData.items.reduce((sum, item) => {
        if (Number(item.variant_id) === Number(variantId)) {
          const isGift = item.properties?._min_gift_product === true
            || item.properties?._min_gift_product_new === true
            || item.properties?._campaign_type === 'auto_gwp_1'
            || item.properties?._campaign_type === 'auto_gwp_2'
            || item.properties?._campaign_type === 'manual_gwp';
          if (!isGift) {
            return sum + Number(item.quantity);
          }
        }
        return sum;
      }, 0);
      return totalQty;
    });
}

let CART_MUTATION_LOCK = false;
class AddToCart extends HTMLElement {
  constructor() {
    super();
    this.miniCart = document.querySelector('mini-cart');
    this.addEventListener('click', this.onClickHandler.bind(this));
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  onClickHandler() {

     if (CART_MUTATION_LOCK) return;
    CART_MUTATION_LOCK = true;

    const variantId = this.dataset.variantId;
    const _this = this;
    if (!variantId) return;

    // Fallback for non-drawer carts.
    if (document.body.classList.contains('template-cart') || !window.shopSettings.cartDrawer) {
      Shopify.postLink(window.routes.cart_add_url, {
        parameters: { id: variantId, quantity: 1 }
      });
      return;
    }

    const limitSetting = window.max_limits?.max_limit;
    this.maxQty = (!limitSetting || parseInt(limitSetting, 10) === 0)
      ? Infinity
      : parseInt(limitSetting, 10);

    this.setAttribute('disabled', true);
    this.classList.add('loading');
    const sections = this.miniCart
      ? this.miniCart.getSectionsToRender().map(section => section.id)
      : [];

    // Get discount settings.
    const discountRule = window.discount.discount_rule; // e.g., "1for10,2for20,3for45"
    const enableDiscount = window.discount.enableDiscount;
    const anyProduct = window.discount.anyProduct;
    const prerequisiteSKUs = window.discount.skus;
    const free_gift_new = window.min_gift.free_git_new;
    const free_gift = window.min_gift.free_git;
    const enabled_gwp1 = window.min_gift.enabled_gwp1;
    const enabled_gwp2 = window.min_gift.enabled_gwp2;
    // console.log("Discount Rule:", discountRule);
    // console.log("Discount Enabled:", enableDiscount);
    // console.log("Any Product:", anyProduct);
    // console.log("Prerequisite SKUs:", prerequisiteSKUs);

    // Always add one unit per click.
    const qtyToAdd = 1;

  
    const sku = this.dataset.sku || '';
   

    getTotalQuantityForVariant(variantId).then(existingQty => {
      // Calculate new total quantity.
      const totalQty = qtyToAdd + existingQty;
     

      if (totalQty > this.maxQty) {
        _this.classList.remove("loading");
        _this.removeAttribute("disabled");

        // Create toast container if it doesn't exist
        let toastContainer = document.querySelector('.max-limit-toast');
        if (!toastContainer) {
          toastContainer = document.createElement('div');
          toastContainer.className = 'max-limit-toast';
          document.body.appendChild(toastContainer);
        }

        toastContainer.textContent = `You can only add a maximum of ${this.maxQty} of this product.`;

        toastContainer.style.opacity = '1';
        setTimeout(() => {
          toastContainer.style.opacity = '0';
        }, 3000);

        return;
      }

      // Determine the matching discount rule based on total quantity.
      const discountRulesArray = discountRule.split(',');
      let matchedRule = "";
      // Look for an exact match.
      discountRulesArray.forEach(rule => {
        let parts = rule.split('for'); // e.g., "2for20" → ["2", "20"]
        if (parseInt(parts[0], 10) === totalQty) {
          matchedRule = rule;
        }
      });
      // If no exact match and totalQty exceeds the highest rule, use the last rule.
      if (!matchedRule) {
        let lastRule = discountRulesArray[discountRulesArray.length - 1];
        let lastQty = parseInt(lastRule.split('for')[0], 10);

        // Find the closest applicable rule
        let closestRule = null;
        for (let rule of discountRulesArray) {
          let ruleQty = parseInt(rule.split('for')[0], 10);
          if (ruleQty <= totalQty) {
            closestRule = rule;
          } else {
            break;
          }
        }

        matchedRule = closestRule || lastRule;
      }

      // console.log("Matched Discount Rule:", matchedRule);



      // Build the dynamic property if discount is enabled.
      let dynamicprop = {};

      const enableTierDiscount = window.TierDiscount?.enableTierDiscount === true;
      // console.log(enableTierDiscount, "enableTierDiscount");

      if (enableTierDiscount) {
        dynamicprop["_tiered_discount_minspend"] = "yes";
      }
      else if (enableDiscount && !enabled_gwp1 && !enabled_gwp2) {
        if (anyProduct) {
          dynamicprop = { "_dynamic_val": matchedRule };
        } else {
          if (prerequisiteSKUs.includes(sku)) {
            dynamicprop = { "_dynamic_val": matchedRule };
          }
        }
      }
      // 🔽 Inject __discount_rate from settings if configured

      const actualProductId = parseInt(this.dataset.productId); // get actual product ID
      const distRate = window.dist_rate || {};

      // Extract enable flags
      const isEnabled1 = distRate.enable_discount_rate === true || distRate.enable_discount_rate === 'true';
      const isEnabled2 = distRate.enable_discount_rate2 === true || distRate.enable_discount_rate2 === 'true';

      // Extract discount fields and their product ID sets
      const discountRate1 = parseFloat(distRate.dist_per);
      const hasRate1 = isEnabled1 && !isNaN(discountRate1);
      const productIds1 = hasRate1 ? (distRate.dist_product || "").split(',').map(id => id.trim()).filter(Boolean) : [];

      const discountRate2 = parseFloat(distRate.dist_per2);
      const hasRate2 = isEnabled2 && !isNaN(discountRate2);
      const productIds2 = hasRate2 ? (distRate.dist_product2 || "").split(',').map(id => id.trim()).filter(Boolean) : [];

      // Determine applicable discount
      let finalDiscount = null;

      if (
        hasRate1 &&
        (productIds1.length === 0 || productIds1.includes(actualProductId.toString()))
      ) {
        finalDiscount = discountRate1;
      }

      if (
        finalDiscount === null &&
        hasRate2 &&
        (productIds2.length === 0 || productIds2.includes(actualProductId.toString()))
      ) {
        finalDiscount = discountRate2;
      }

      // Fallback if both lists are empty and rate1 is valid
      if (
        finalDiscount === null &&
        hasRate1 &&
        productIds1.length === 0 &&
        (!hasRate2 || productIds2.length === 0)
      ) {
        finalDiscount = discountRate1;
      }

      // Apply discount if determined
      if (finalDiscount !== null) {
        dynamicprop["_discount_rate"] = finalDiscount;
      }




      // console.log("Dynamic Property:", dynamicprop);

      // Now, fetch the current cart again to get the full item details.
      fetch(`${window.routes.cart_url}.js`)
        .then(response => response.json())
        .then(cartData => {
          document.dispatchEvent(new CustomEvent("cart:updated", {
            detail: { cart: cartData }
          }));


          // Find an existing item by variant ID.
          let existingItem = cartData.items.find(item => {
            const isGift = item.properties?._min_gift_product === true
              || item.properties?._min_gift_product_new === true
              || item.properties?._campaign_type === 'auto_gwp_1'
              || item.properties?._campaign_type === 'auto_gwp_2'
              || item.properties?._campaign_type === 'manual_gwp';
            return Number(item.id) === Number(variantId) && !isGift;
          });
          let endpoint, payload;
          if (existingItem) {
            endpoint = window.routes.cart_change_url;
            payload = {
              id: existingItem.key,
              quantity: totalQty,
              properties: dynamicprop,
              sections: sections,
              sections_url: window.location.pathname
            };
            // console.log("Updating existing item with payload:", payload);
          } else {
            endpoint = window.routes.cart_add_url;
            payload = {
              items: [{
                id: variantId,
                quantity: totalQty,
                properties: dynamicprop
              }],
              sections: sections,
              sections_url: window.location.pathname
            };
            // console.log("Adding new item with payload:", payload);
          }
          const url = endpoint + '.js';

          // Call the appropriate endpoint.
          return fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest'
            },
            body: JSON.stringify(payload)
          });
        })
        .then(response => response.json())
        .then(parsedState => {
          if (parsedState.status === 422) {
            console.error("Error adding product:", parsedState.description);
            document.dispatchEvent(new CustomEvent("ajaxProduct:error", {
              detail: { errorMessage: parsedState.description }
            }));
          } else {
            var Main_response = parsedState;
            // Immediately update drawer UI for a fast response
            if (_this.miniCart) {
              _this.miniCart.renderContents(Main_response);
            }
            document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product: Main_response } }));
            // Continue with gift logic without blocking UI
            fetch(`${window.routes.cart_url}.js`)
              .then(response => response.json())
              .then(cartData => {

                document.dispatchEvent(new CustomEvent("cart:updated", {
                  detail: { cart: cartData }
                }));
                // console.log("Updated cart data for free gifts:", cartData);
                const modalEl = document.getElementById('waitlist-form-data');
                if (modalEl) {
                  modalEl.style.display = 'none';
                }


                const free_gift = window.min_gift.free_git;
                const minPrice = window.min_gift.min_price;
                const campaign_name = window.min_gift.campaign_name;
                const isGiftAdded = cartData.items.some(item => item.id == free_gift && item.properties?._min_gift_product === true);
                const free_gift_new = window.min_gift.free_git_new;
                const minPriceNew = window.min_gift.min_price_new;
                const campaign_name_new = window.min_gift.campaign_name_new;
                const isGiftAddedNew = cartData.items.some(item => item.id == free_gift_new && item.properties?._min_gift_product_new === true);
                const enabled_gwp1 = window.min_gift.enabled_gwp1;
                const enabled_gwp2 = window.min_gift.enabled_gwp2;


                // variant id based
                const pr_gift = window.prod_gift.pr_gift;
                const enabled_prod_gift = window.prod_gift.enabled_prod_gift;
                const allowedVariants = window.prod_gift.variant_ids;



                // Does the cart contain one of the required variants?
                const hasRequiredVariant = cartData.items.some(item =>
                  allowedVariants.includes(item.id.toString())
                );

                // Is the variant gift already in the cart?
                const isVariantGiftAdded = cartData.items.some(item => item.id == pr_gift);

                if (enabled_prod_gift && hasRequiredVariant) {
                  addFreeGift(pr_gift, isVariantGiftAdded, 0, 0, "auto_gwp_2", "", "_min_gift_product_new", cartData, enabled_prod_gift
                  );
                } else {
                  console.log("here");

                  removeFreeGift("_min_gift_product_new", cartData);
                }

                // const cartTotalExcludingGiftCard = cartData.items
                //   .filter(item => item.handle != "gift-card")
                //   .reduce((total, item) => total + item.line_price, 0);

                const cartTotalExcludingGiftCard = cartData.items
                  .filter(item =>
                    item.handle !== "gift-card" &&               // exclude gift-card
                    item.properties?._campaign_type !== "auto_gwp_1" &&   // exclude auto GWP
                    item.properties?._min_gift_product !== true    &&          // exclude minimum gift product
                    item.properties?._campaign_type !== "auto_gwp_2" &&
                    item.properties?._min_gift_product_new !== true        // exclude minimum gift product
                  )
                  .reduce((total, item) => total + item.original_line_price, 0);

                // console.log(cartsubTotalExcludingGiftCard, ":sub totl");
                // console.log(cartTotalExcludingGiftCard, ": totl");

               async function handleBothGwps() {

                
                 if (window.b3g1_config && window.b3g1_config.enabled) {
                  const b3g1Config = window.b3g1_config;
                  const b3g1Exclude = b3g1Config.exclude_ids || [];
                  
                  // Refetch cart to get latest state
                  const currentCart = await fetch(`${window.routes.cart_url}.js`).then(r => r.json());
                  
                  const b3g1Count = currentCart.items.reduce((total, item) => {
                    if (item.properties && (
                      item.properties._campaign_type || 
                      item.properties._min_gift_product || 
                      item.properties._min_gift_product_new ||
                      item.properties._b3g1_gift
                    )) return total;
                    if (b3g1Exclude.includes(item.product_id.toString()) || b3g1Exclude.includes(item.variant_id.toString())) return total;
                    return total + item.quantity;
                  }, 0);

                  const giftId = b3g1Config.gift_variant_id;
                  const isB3G1Added = currentCart.items.find(item => item.id == giftId && item.properties?._campaign_type === b3g1Config.campaign_type);

                  if (b3g1Count >= 3) {
                    if (!isB3G1Added && giftId != 0) {
                      const props = {
                        "_campaign_type": b3g1Config.campaign_type,
                        "_campaign_name": b3g1Config.campaign_name,
                        "_discount_quantity": "1",
                        "_b3g1_gift": true
                      };
                      await fetch(`${window.routes.cart_add_url}.js`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' },
                        body: JSON.stringify({ items: [{ id: parseInt(giftId), quantity: 1, properties: props }], sections, sections_url: window.location.pathname })
                      })
                      .then(r => r.json())
                      .then(r => changeContent(_this, r));
                    }
                  } else {
                    if (isB3G1Added) {
                      await fetch(`${window.routes.cart_change_url}.js`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' },
                        body: JSON.stringify({ id: isB3G1Added.key, quantity: 0, sections, sections_url: window.location.pathname })
                      })
                      .then(r => r.json())
                      .then(r => changeContent(_this, r));
                    }
                  }
                }

                // console.log(!window.b3g1_config.enabled ,"!window.b3g1_config.enabled");
                // console.log(window.b3g1_config.enabled ,"window.b3g1_config.enabled");

                
                if (!window.b3g1_config.enabled){
                if (enabled_gwp1 && !isGiftAdded) {
                  await addFreeGift(
                    free_gift,
                    isGiftAdded,
                    minPrice,
                    cartTotalExcludingGiftCard,
                    "auto_gwp_1",
                    campaign_name,
                    "_min_gift_product",
                    cartData,
                    enabled_gwp1
                  );
                }

                if (!enabled_prod_gift && enabled_gwp2 && !isGiftAddedNew) {
                  const isGiftAddedNewFresh = cartData.items.some(item =>
                    item.id == free_gift_new &&
                    item.properties?._campaign_type === "auto_gwp_2"
                  );

                  await addFreeGift(
                    free_gift_new,
                    isGiftAddedNewFresh,
                    minPriceNew,
                    cartTotalExcludingGiftCard,
                    "auto_gwp_2",
                    campaign_name_new,
                    "_min_gift_product_new",
                    cartData,
                    enabled_gwp2
                  );
                }
              }


              }

              handleBothGwps();


                const validSKUQty = cartData.items.reduce((total, item) => {
                  if (prerequisiteSKUs.includes(item.sku) && item.id !== free_gift && item.id !== free_gift_new) {
                    return total + Number(item.quantity);
                  }
                  return total;
                }, 0);

                const allSKUQty = cartData.items.reduce((total, item) => {
                  if (item.id !== free_gift && item.id !== free_gift_new) {
                    return total + Number(item.quantity);
                  }
                  return total;
                }, 0);

                // console.log("Valid SKU Qty:", validSKUQty);
                // console.log("All SKU Qty:", allSKUQty);


                const discountRulesArray = discountRule.split(',');
                let newMatchedRule = "";
                // Determine which discount rule applies based on total valid SKU quantity.


                let quantityForDiscount = anyProduct ? allSKUQty : validSKUQty;

                discountRulesArray.forEach(rule => {
                  let parts = rule.split('for'); // e.g. "3for45" -> ["3", "45"]
                  if (parseInt(parts[0], 10) === quantityForDiscount) {
                    newMatchedRule = rule;
                  }
                });

                if (!newMatchedRule) {
                  let lastRule = discountRulesArray[discountRulesArray.length - 1];
                  let lastQty = parseInt(lastRule.split('for')[0], 10);

                  // Find the closest rule where qty <= totalQty
                  let closestRule = null;
                  for (let rule of discountRulesArray) {
                    let ruleQty = parseInt(rule.split('for')[0], 10);
                    if (ruleQty <= quantityForDiscount) {
                      closestRule = rule;
                    } else {
                      break; // Stop when a larger qty is found
                    }
                  }

                  newMatchedRule = closestRule || lastRule; // Use closest match or fallback to lastRule
                }
                // console.log("New closestRulevalidSKUQty:", newMatchedRule);
                // Apply discount updates to valid SKU items if discount is enabled and not for anyProduct.

                if (!enabled_gwp1 && !enabled_gwp2) {

                  if (enableDiscount && !anyProduct && newMatchedRule !== "") {
                    const validSKUItems = cartData.items.filter(item => prerequisiteSKUs.includes(item.sku));
                    updateValidSKUItems(validSKUItems, newMatchedRule, sections, cartData);
                  } else
                    if (enableDiscount) {
                      const validSKUItems = cartData.items.filter(item => item.id !== free_gift && item.id !== free_gift_new);
                      // console.log("object", validSKUItems);
                      updateValidSKUItems(validSKUItems, newMatchedRule, sections, cartData);
                    }
                }

                // --- Chained update function ---
                async function updateValidSKUItems(validSKUItems, discountRule, sections, cartData) {
                  console.log('Starting chain update with discount rule:', discountRule);
                  for (const item of validSKUItems) {
                    // Derive the line number for this item.
                    const lineNumber = cartData.items.findIndex(i => i.key === item.key) + 1;

                    console.log("olineNumberbject",);
                    const payload = {
                      line: lineNumber,
                      quantity: item.quantity,
                      properties: {
                        ...item.properties,
                        _dynamic_val: discountRule,
                        _update_id: Date.now() // Optional unique identifier
                      },
                      sections: sections,
                      sections_url: window.location.pathname
                    };
                    console.log(`Updating SKU: ${item.sku}, Payload:`, payload);
                    try {
                      const response = await fetch(`${window.routes.cart_change_url}.js`, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                          'X-Requested-With': 'xmlhttprequest'
                        },
                        body: JSON.stringify(payload)
                      });
                      const data = await response.json();
                      // console.log(`Update response for ${item.sku}:`, data);
                    } catch (error) {
                      console.error(`Error updating ${item.sku}:`, error);
                    }
                    // Delay slightly before the next request.
                    await new Promise(resolve => setTimeout(resolve, 100));
                  }
                }

              });
          }

          function addFreeGift(freeGiftId, isGiftAdded, minPrice, cartTotal, campaignType, campaignName, giftProperty, cartData, enabledGwp) {
            if (cartTotal >= minPrice && freeGiftId != 0 && minPrice >= 0 && enabledGwp) {
              if (!isGiftAdded) {
                const props = {
                  "_campaign_type": campaignType,
                  "_discount_quantity": "1",
                  "_campaign_name": campaignName,
                  [giftProperty]: true
                };
                const items = [{ quantity: 1, id: parseInt(freeGiftId), properties: props }];
                console.log(`Adding free gift (${campaignType}):`, items);
                fetch(`${window.routes.cart_add_url}.js`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                  },
                  body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
                })
                  .then(response => response.json())
                  .then(response => {
                    console.log(`Free gift response (${campaignType}):`, response);
                    changeContent(_this, response);
                  });
              } else {
                changeContent(_this, Main_response);
              }
            } else {
              removeFreeGift(giftProperty, cartData);
              // console.log("removed gs");
            }
          }

          function removeFreeGift(giftProperty, cartData) {
            if (!cartData || !cartData.items) {
              console.error("Cart data is undefined or empty, skipping gift removal.");
              return;
            }
            const giftItems = cartData.items.filter(item => item.properties?.[giftProperty] === true);
        

            if (giftItems.length) {
              const removalRequests = giftItems.map(giftItem => {
                return fetch(`${window.routes.cart_change_url}.js`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                  },
                  body: JSON.stringify({ id: giftItem.key, quantity: 0, sections, sections_url: window.location.pathname })
                })
                  .then(response => response.json());
              });
              Promise.all(removalRequests).then(responses => {
                // console.log("Gift removal responses:", responses);
                changeContent(_this, responses[responses.length - 1]);
              });
            } else {
              changeContent(_this, Main_response);
            }
          }

          function changeContent(_this, parsedState) {
            _this.miniCart && _this.miniCart.renderContents(parsedState);
            document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
              detail: { product: parsedState }
            }));
          }
        })
        .catch(e => {
          console.error("Fetch error:", e);
        })
        .finally(() => {
          CART_MUTATION_LOCK = false;
          _this.classList.remove("loading");
          _this.removeAttribute("disabled");
        });

    });
  }
}
customElements.define("add-to-cart", AddToCart);



class PriceMoney extends HTMLElement {
  constructor() {
    super();

    if (this.shouldInit()) {
      this.init();
    }
  }

  shouldInit() {
    if (document.body.dataset.priceSuperscript === undefined) {
      return false;
    }

    const moneyFormat = theme.shopSettings.moneyFormat.toLowerCase();
    if (moneyFormat.indexOf('class=') !== -1) {
      return false;
    }

    return true;
  }

  init() {
    const currencies_using_comma_decimals = 'ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,TRY,UYU,VES,VND'.split(',');
    const symbol = theme.shopSettings.moneyFormat.replace(/\{{.*}}/, '').trim();
    const bdi = this.querySelector('bdi');
    const price = bdi.textContent.replace(theme.shopSettings.isoCode, '');
    let html = price.replace(' ', '');
    let money_symbol_decimal = '.';
    if (currencies_using_comma_decimals.includes(theme.shopSettings.isoCode)) {
      money_symbol_decimal = ',';
    }
    if (price.includes(money_symbol_decimal)) {
      if (price.lastIndexOf(symbol) + symbol.length === price.length) {
        const price_without_symbol = price.slice(0, price.lastIndexOf(symbol));
        const price_without_decimal = price.slice(0, price.lastIndexOf(money_symbol_decimal));
        const decimal = price_without_symbol.replace(price_without_decimal, '').trim();
        html = html.replace(decimal, `<sup class="price__suffix">${decimal}</sup>`);
      }
      else {
        const price_without_decimal = price.slice(0, price.lastIndexOf(money_symbol_decimal));
        const decimal = price.replace(price_without_decimal, '').trim();
        html = html.replace(decimal, `<span class="price__suffix">${decimal}</span>`);
      }
    }
    html = html.replace(symbol, `<span class="price__prefix">${symbol}</span>`);
    if (theme.shopSettings.currencyCode) {
      html = html + " " + theme.shopSettings.isoCode;
    }
    bdi.innerHTML = html;
  }
}
customElements.define('price-money', PriceMoney);

class SlideshowComponent extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      small: this.querySelector('.slideshow__left'),
      content: this.querySelector('.slideshow__content'),
      large: this.querySelector('.slideshow__right')
    }
    this.settings = {
      autorotate: this.dataset.autorotate == 'true',
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
      slidesSmall: this.elements.small.querySelectorAll('.slideshow__image'),
      slidesLarge: this.elements.large.querySelectorAll('.slideshow__image')
    };

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
    this.matchMedia();
  }

  init() {
    setTimeout(() => {
      this.flickitySmall = new Flickity(this.elements.small, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: false,
        setGallerySize: false,
        autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
      });

      this.flickityContent = new Flickity(this.elements.content, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        draggable: theme.config.mqlSmall ? true : false,
        asNavFor: this.elements.small,
        adaptiveHeight: true,
        arrowShape: 'M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z',
        on: {
          ready: () => {
            const prevNextButtons = this.querySelectorAll('.flickity-button');
            if (prevNextButtons) {
              prevNextButtons.forEach((button) => {
                button.setAttribute('tabindex', '-1');
              });
            }
          }
        }
      });

      this.flickityLarge = new Flickity(this.elements.large, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        setGallerySize: false,
        asNavFor: this.elements.content,
        dragThreshold: 10
      });

      this.bindEvents();
    });
  }

  bindEvents() {
    this.flickitySmall.on('scroll', () => {
      this.flickitySmall.slides.forEach((slide, i) => {
        const flickity = this.flickitySmall;
        const image = this.settings.slidesSmall[i];
        let x = 0;

        if (image) {
          if (0 === i) {
            x = Math.abs(flickity.x) > flickity.slidesWidth ? (flickity.slidesWidth + flickity.x + flickity.slides[flickity.slides.length - 1].outerWidth + slide.target) : (slide.target + flickity.x);
          }
          else if (i === flickity.slides.length - 1) {
            x = Math.abs(flickity.x) + flickity.slides[i].outerWidth < flickity.slidesWidth ? (slide.target - flickity.slidesWidth + flickity.x - flickity.slides[i].outerWidth) : (slide.target + flickity.x);
          }
          else {
            x = slide.target + flickity.x;
          }

          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = 'translateX(' + x * (-1 / 2) + 'px)';
          }
        }
      });
    });

    this.flickityLarge.on('scroll', () => {
      this.flickityLarge.slides.forEach((slide, i) => {
        const flickity = this.flickityLarge;
        const image = this.settings.slidesLarge[i];
        let x = 0;

        if (image) {
          if (0 === i) {
            x = Math.abs(flickity.x) > flickity.slidesWidth ? (flickity.slidesWidth + flickity.x + flickity.slides[flickity.slides.length - 1].outerWidth + slide.target) : (slide.target + flickity.x);
          }
          else if (i === flickity.slides.length - 1) {
            x = Math.abs(flickity.x) + flickity.slides[i].outerWidth < flickity.slidesWidth ? (slide.target - flickity.slidesWidth + flickity.x - flickity.slides[i].outerWidth) : (slide.target + flickity.x);
          }
          else {
            x = slide.target + flickity.x;
          }

          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = 'translateX(' + x * (-1 / 2) + 'px)';
          }
        }
      });
    });

    this.elements.content.querySelector('.flickity-button.next').addEventListener('click', () => {
      this.flickitySmall && this.flickitySmall.next();
    });

    this.elements.content.querySelector('.flickity-button.previous').addEventListener('click', () => {
      this.flickitySmall && this.flickitySmall.previous();
    });

    this.elements.content.querySelectorAll('.flickity-page-dot').forEach((button) => {
      button.addEventListener('click', () => {
      });
    });

    let currentIndex = null,
      swipeDirection = null;

    // Detect swipe direction
    this.flickityLarge.on('dragMove', (_event, _pointer, moveVector) => {
      currentIndex = this.flickityLarge.selectedIndex;
      swipeDirection = this.getSwipeDirection(moveVector);
    });

    // Do stuff based on a successful swipe and it's direction
    this.flickityLarge.on('dragEnd', () => {
      if (this.flickityLarge.selectedIndex !== currentIndex) {

        if (swipeDirection === 'left') {
          this.flickitySmall.next();
        }
        else {
          this.flickitySmall.previous();
        }
      }
    });
  }
  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? 'right' : 'left';
  }

  matchMedia() {
    document.addEventListener('matchSmall', () => {
      this.unload();
      this.init();
    });

    document.addEventListener('unmatchSmall', () => {
      this.unload();
      this.init();
    });
  }

  unload() {
    if (this.flickitySmall && typeof this.flickitySmall.destroy === 'function') {
      this.flickitySmall.destroy();
    }
    if (this.flickityContent && typeof this.flickityContent.destroy === 'function') {
      this.flickityContent.destroy();
    }
    if (this.flickityLarge && typeof this.flickityLarge.destroy === 'function') {
      this.flickityLarge.destroy();
    }
  }
}
customElements.define('slideshow-component', SlideshowComponent);

class TestimonialsComponent extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.slider == 'true') {
      this.settings = {
        autorotate: this.dataset.autorotate == 'true',
        autorotateSpeed: parseInt(this.dataset.autorotateSpeed)
      };
      this.slider = this.querySelector('.testimonial__list');
      this.previews = this.querySelector('.testimonial__previews');

      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600
      });
      theme.initWhenVisible({
        element: this,
        callback: this.update.bind(this),
        threshold: 0
      });
    }
  }

  init() {
    setTimeout(() => {
      if (this.slider) {
        this.flickity = new Flickity(this.slider, {
          accessibility: false,
          rightToLeft: theme.config.rtl,
          prevNextButtons: true,
          arrowShape: 'M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z',
          pageDots: false,
          wrapAround: true,
          draggable: true,
          cellAlign: 'center',
          autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
          pauseAutoPlayOnHover: true,
          asNavFor: this.previews
        });
      }

      this.flickityNav = new Flickity(this.previews, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: this.flickity ? false : true,
        arrowShape: this.flickity ? '' : 'M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z',
        pageDots: false,
        wrapAround: true,
        selectedAttraction: 0.2,
        friction: 0.8,
        adaptiveHeight: true,
      });

      this.flickityNav.previous();
      if (this.settings.autorotate) {
        this.flickity.pausePlayer();
      }

      this.flickity && this.flickity.on('staticClick', (_event, _pointer, _cellElement, cellIndex) => {
        if (typeof cellIndex == 'number') {
          this.flickityNav.select(cellIndex);
        }
      });

      // Do stuff based on a successful swipe and it's direction
      this.flickity && this.flickity.on('change', (index) => {
        this.flickityNav.select(index);
      });
    });
  }

  update() {
    setTimeout(() => {
      if (this.flickity && this.flickityNav) {
        this.flickityNav.next();
        if (this.settings.autorotate) {
          this.flickity.unpausePlayer();
        }
      }
    }, 300);
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? 'right' : 'left';
  }
}
customElements.define('testimonials-component', TestimonialsComponent);

class UseAnimate extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    this.setAttribute('animate', '');
  }
}
customElements.define('use-animate', UseAnimate);

class AnimateSticky extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const _ = this;
    if (window.innerWidth < 768 && this.classList.contains('sticky-cart-wrapper')) {
      const mobileSwatchTrigger = document.querySelector('.product-form__submit');
      if (mobileSwatchTrigger) {
        const observerCallback = (entries) => {
          entries.forEach((entry) => {
            // Get the bounding rectangle for the trigger element.
            const rect = entry.boundingClientRect;

            // When the trigger is at (or near) the top of the viewport:
            if (rect.top <= 0) {
              // Show the sticky element.
              window.requestAnimationFrame(this.reveal.bind(this));
            } else {
              // Otherwise (when the trigger is lower in the viewport), hide the sticky element.
              window.requestAnimationFrame(this.reset.bind(this));
            }
          });
        };

        // You can also customize the observer options if needed.
        const observerOptions = {
          // For example, you might use a rootMargin to fine-tune when the callback is fired.
          root: null,
          threshold: 0
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        observer.observe(mobileSwatchTrigger);
      }
    }
    else {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.getOffsetTop(this)) {
        window.requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.requestAnimationFrame(this.reset.bind(this));
      }
    }
  }

  reveal() {
    this.setAttribute('animate', '');
  }

  reset() {
    this.removeAttribute('animate');
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
}
customElements.define('animate-sticky', AnimateSticky);

class LookbookComponent extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    const hotspots = this.querySelectorAll('.look__hotspot');
    hotspots.forEach((hotspot) => {
      hotspot.classList.add('is-active');
    });

    setTimeout(() => {
      hotspots.forEach((hotspot) => {
        hotspot.classList.remove('is-active');
      });
    }, 3e3);
  }
}
customElements.define('lookbook-component', LookbookComponent);

class TabCollage extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.tab-collage__heading').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    if (this.dataset.accordion === undefined) {
      this.querySelectorAll('.tab-collage__heading').forEach(
        (button) => button.addEventListener('mouseover', this.onButtonClick.bind(this))
      );
    }
  }

  onButtonClick(event) {
    const target = event.target;
    if (target.classList.contains('is-active')) {
      if (this.dataset.accordion !== undefined) {
        target.classList.remove('is-active');
      }
      return;
    }

    this.pauseAllMedia();

    this.querySelectorAll('[data-block-id]').forEach((button) => {
      if (target.dataset.blockId === button.dataset.blockId) {
        button.classList.add('is-active');
      }
      else {
        button.classList.remove('is-active');
      }
    });
  }

  pauseAllMedia() {
    this.querySelectorAll('video-section[data-type="youtube"] iframe').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('video-section[data-type="vimeo"] iframe').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('tab-collage', TabCollage);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest('.product-countdown');
    //this.date = new Date(Date.parse(this.dataset.date)).getTime();
    const dateArray = this.dataset.date.split('.');
    this.date = new Date(dateArray[2], dateArray[1] - 1, dateArray[0]).getTime();

    if (isNaN(this.date)) {
      this.date = new Date(this.dataset.date.replace(/-/g, "/")).getTime();

      if (isNaN(this.date)) {
        this.unload();
        return;
      }
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    this.timer();
    this.dataset.interval = setInterval(this.timer.bind(this), 1000);
  }

  timer() {
    const now = new Date(),
      countTo = new Date(this.date),
      timeDifference = (countTo - now);

    if (timeDifference < 0) {
      this.unload();
      return;
    }

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000;

    const days = Math.floor(timeDifference / (secondsInADay) * 1);
    const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
    const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
    const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);

    if (this.dataset.compact == 'true') {
      const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}${theme.dateStrings.d}</span></div>` : '';
      const otherHTML = `<div class="countdown__item"><span>${hours > 9 ? hours : '0' + hours}:${mins > 9 ? mins : '0' + mins}:${secs > 9 ? secs : '0' + secs}</span></div>`;

      this.innerHTML = dayHTML + otherHTML;
    }
    else {
      const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}</span> ${days == 1 ? theme.dateStrings.day : theme.dateStrings.days}</div>` : '';
      const hourHTML = `<div class="countdown__item"><span>${hours}</span> ${hours == 1 ? theme.dateStrings.hour : theme.dateStrings.hours}</div>`;
      const minHTML = `<div class="countdown__item"><span>${mins}</span> ${mins == 1 ? theme.dateStrings.minute : theme.dateStrings.minutes}</div>`;
      const secHTML = `<div class="countdown__item"><span>${secs}</span> ${secs == 1 ? theme.dateStrings.second : theme.dateStrings.seconds}</div>`;

      this.innerHTML = dayHTML + hourHTML + minHTML + secHTML;
    }
  }

  unload() {
    if (this.dataset.interval) {
      clearInterval(this.dataset.interval);
    }

    this.classList.add('hidden');
    if (this.parent) {
      this.parent.classList.add('hidden');
    }
  }
}
customElements.define('countdown-timer', CountdownTimer);

class GMap extends HTMLElement {
  constructor() {
    super();

    if (!this.dataset.apiKey || !this.dataset.mapAddress) {
      return;
    }

    theme.initWhenVisible({
      element: this,
      callback: this.prepMapApi.bind(this),
      threshold: 200
    });
  }

  prepMapApi() {
    this.loadScript().then(this.initMap.bind(this));
  }

  loadScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.dataset.apiKey;
    });
  }

  initMap() {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: this.dataset.mapAddress }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) {
        if (Shopify.designMode) { }
      }
      else {
        const mapOptions = {
          zoom: parseInt(this.dataset.zoom),
          center: results[0].geometry.location,
          draggable: true,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          disableDefaultUI: true
        };

        const map = new google.maps.Map(this, mapOptions), center = map.getCenter();

        map.setCenter(center);

        const icon = {
          path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
          fillColor: this.dataset.markerColor,
          fillOpacity: 1,
          anchor: new google.maps.Point(15, 55),
          strokeWeight: 0,
          scale: 0.6
        };

        new google.maps.Marker({
          map: map,
          position: map.getCenter(),
          icon: icon
        });

        const styledMapType = new google.maps.StyledMapType(JSON.parse(this.parentNode.querySelector('[data-gmap-style]').innerHTML));

        map.mapTypes.set('styled_map', styledMapType);
        map.setMapTypeId('styled_map');

        google.maps.event.addDomListener(window, 'resize', function () {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(center);
        });
      }
    });
  }
}
customElements.define('g-map', GMap);

class RelatedButtons extends HTMLElement {
  constructor() {
    super();

    if (!document.querySelector(this.dataset.scrollto)) {
      this.classList.add('hidden');
      return;
    }

    window.addEventListener('scroll', this.checkListener.bind(this));
    this.querySelectorAll('a').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  checkListener() {
    const element = document.querySelector(this.dataset.scrollto);
    const show = window.scrollY >= element.offsetTop - element.clientHeight;

    if (show) {
      this.classList.add('is-flipped');
    } else {
      this.classList.remove('is-flipped');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.target;
    const scrollIntoView = document.querySelector(target.getAttribute('href'));

    scrollIntoView.scrollIntoView({ behavior: "smooth" });
  }
}
customElements.define('related-buttons', RelatedButtons);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    // We save the product ID in local storage to be eventually used for recently viewed section
    if (isStorageSupported('local')) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = 'beyours:recently-viewed';
      const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');

      // We check if the current product already exists, and if it does not, we add it at the start
      if (!items.includes(productId)) {
        items.unshift(productId);
      }

      // By keeping only the 4 most recent
      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 5)));
    }
  }
}
customElements.define('product-recently-viewed', ProductRecentlyViewed);

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    fetch(this.dataset.url + this.getQueryString())
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('recently-viewed-products');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          this.initSwiper();
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  getQueryString() {
    const cookieName = 'beyours:recently-viewed';
    const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");

    if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
      items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
    }

    return items.map((item) => "id:" + item).slice(0, 4).join(" OR ");
  }

  initSwiper() {
    setTimeout(() => {
      new Swiper(".recent-slider", {
        slidesPerView: "auto",
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }, 100);
  }
}

customElements.define("recently-viewed-products", RecentlyViewedProducts);


class VideoSection extends HTMLElement {
  constructor() {
    super();

    this.background = this.dataset.initMode !== 'template';
    this.loop = this.dataset.loop;

    if (this.background) {
      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
    else {
      this.init();
    }
  }

  init() {
    this.parentSelector = this.dataset.parent || '.media-wrapper';
    this.parent = this.closest(this.parentSelector);

    switch (this.dataset.type) {
      case 'youtube':
        this.initYoutubeVideo();
        break;

      case 'vimeo':
        this.initVimeoVideo();
        break;

      case 'mp4':
        this.initMp4Video();
        break;
    }
  }

  initYoutubeVideo() {
    this.setAsLoading();
    this.loadScript('youtube').then(this.setupYoutubePlayer.bind(this));
  }

  initVimeoVideo() {
    this.setAsLoading();
    this.loadScript('vimeo').then(this.setupVimeoPlayer.bind(this));
  }

  initMp4Video() {
    const player = this.querySelector('video');

    if (player) {
      const promise = player.play();

      // Edge does not return a promise (video still plays)
      if (typeof promise !== 'undefined') {
        promise.then(function () {
          // playback normal
        }).catch(function () {
          player.setAttribute('controls', '');
        });
      }
    }
  }

  loadScript(videoType) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = videoType === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
    });
  }

  setAsLoading() {
    this.parent.setAttribute('loading', true);
  }

  setAsLoaded() {
    this.parent.removeAttribute('loading');
    this.parent.setAttribute('loaded', true);
  }

  setupYoutubePlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.YT) {
        window.YT.ready(() => {
          const element = document.createElement('div');
          this.appendChild(element);

          this.player = new YT.Player(element, {
            videoId: videoId,
            playerVars: {
              showinfo: 0,
              controls: !this.background,
              fs: !this.background,
              rel: 0,
              height: '100%',
              width: '100%',
              iv_load_policy: 3,
              html5: 1,
              loop: this.loop == '1' ? 1 : 0,
              playlist: videoId,
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1
            },
            events: {
              onReady: this.onYoutubeReady.bind(this),
              onStateChange: this.onYoutubeStateChange.bind(this)
            }
          });
          clearInterval(playerInterval);
        });
      }
    }, 50);
  }

  onYoutubeReady() {
    this.iframe = this.querySelector('iframe'); // iframe once YT loads
    this.iframe.setAttribute('tabindex', '-1');

    this.background && this.player.mute();
    if (typeof this.player.playVideo === 'function') this.player.playVideo();

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        entry.isIntersecting ? this.youtubePlay() : this.youtubePause();
      });
    }, { rootMargin: '0px 0px 50px 0px' });

    observer.observe(this.iframe);
  }

  onYoutubeStateChange(event) {
    switch (event.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (this.attemptedToPlay) {
          this.setAsLoaded();
          this.closest('.banner').classList.add('video-interactable');
        }
        break;
      case 0: // ended, loop it
        this.youtubePlay();
        break;
      case 1: // playing
        this.setAsLoaded();
        break;
      case 3: // buffering
        this.attemptedToPlay = true;
        break;
    }
  }

  youtubePlay() {
    if (this.background && this.player && typeof this.player.playVideo === 'function') {
      this.player.playVideo();
    }
  }

  youtubePause() {
    if (this.background && this.player && typeof this.player.pauseVideo === 'function') {
      this.player.pauseVideo();
    }
  }

  setupVimeoPlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.Vimeo) {
        this.player = new Vimeo.Player(this, {
          id: videoId,
          autoplay: true,
          autopause: false,
          background: this.background,
          controls: !this.background,
          loop: this.loop == '1' ? true : false,
          playlist: videoId,
          height: '100%',
          width: '100%'
        });
        this.player.ready().then(this.onVimeoReady.bind(this));

        clearInterval(playerInterval);
      }
    }, 50);
  }

  onVimeoReady() {
    this.iframe = this.querySelector('iframe');
    this.iframe.setAttribute('tabindex', '-1');

    this.background && this.player.setMuted(true);

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.vimeoPlay();
        } else {
          this.vimeoPause();
        }
      });
    }, { rootMargin: '0px 0px 50px 0px' });

    observer.observe(this.iframe);
  }

  vimeoPlay() {
    if (this.background && this.player && typeof this.player.play === 'function') {
      this.player.play();
    }
  }

  vimeoPause() {
    if (this.background && this.player && typeof this.player.pause === 'function') {
      this.player.pause();
    }
  }
}
customElements.define('video-section', VideoSection);

class BundleProduct extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      souldout: 'price--sold-out',
      onsale: 'price--on-sale',
      nocompare: 'price--no-compare'
    };

    this.addToCart = this.querySelector('add-to-cart');
    this.price = this.querySelector('.price');
    this.variants = this.querySelector('select');
    if (this.variants) {
      this.variants.addEventListener('change', this.onSelectChange.bind(this));
    }
  }

  onSelectChange(event) {
    const variants = event.target;
    const variant = variants.options[variants.selectedIndex];
    const compare_at_price = parseInt(variant.dataset.compare_at_price || 0);
    const price = parseInt(variant.dataset.price || 0);
    const available = variant.dataset.available === 'true';
    const price_varies = variants.dataset.price_varies === 'true';
    const compare_at_price_varies = variants.dataset.compare_at_price_varies === 'true';

    // Remove classes
    this.price.classList.remove(this.classes.souldout);
    this.price.classList.remove(this.classes.onsale);
    this.price.classList.remove(this.classes.nocompare);

    // Add classes
    if (available === false) {
      this.price.classList.add(this.classes.souldout);
    }
    else if (compare_at_price > price && available) {
      this.price.classList.add(this.classes.onsale);
    }
    if (price_varies == false && compare_at_price_varies) {
      this.price.classList.add(this.classes.nocompare);
    }

    // Change price
    const price__regular = this.querySelector('.price__regular');
    price__regular.querySelector('.price-item--regular').innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(price, theme.shopSettings.moneyFormat)}</bdi></price-money>`;

    const price__sale = this.querySelector('.price__sale');
    price__sale.querySelector('.price-item--regular').innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(compare_at_price, theme.shopSettings.moneyFormat)}</bdi></price-money>`;
    price__sale.querySelector('.price-item--sale').innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(price, theme.shopSettings.moneyFormat)}</bdi></price-money>`;

    // Change variant id
    if (this.addToCart) {
      this.addToCart.dataset.variantId = variant.value;
    }
  }
}
customElements.define('bundle-product', BundleProduct);

class BundleProducts extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
    };

    this.miniCart = document.querySelector('mini-cart');
    this.button = this.querySelector('button');
    if (this.button) this.button.addEventListener('click', this.onButtonClick.bind(this));

    this.blocks = this.querySelectorAll('[data-block-id]');
    this.blocks.forEach((block) => block.addEventListener('mouseenter', this.onEnterHandler.bind(this)));
    this.blocks.forEach((block) => block.addEventListener('mouseleave', this.onLeaveHandler.bind(this)));
  }

  onEnterHandler(event) {
    this.classList.add(this.classes.hover);

    const target = event.target;
    const blockId = target.dataset.blockId;
    this.blocks.forEach((block) => {
      if (target.nodeName === 'BUNDLE-PRODUCT') {
        if (block.nodeName === 'BUNDLE-PRODUCT') {
          block.classList.add(this.classes.active);
          return;
        }
      }
      if (block.dataset.blockId === blockId) {
        block.classList.add(this.classes.active);
      }
    });
  }

  onLeaveHandler() {
    this.classList.remove(this.classes.hover);
    this.blocks.forEach((block) => block.classList.remove(this.classes.active));
  }

  onButtonClick(event) {
    event.preventDefault();

    const ids = this.querySelectorAll('[name="id"]');
    const items = {
      items: [...ids].map((e => e.value)).map((e => ({
        id: e,
        quantity: 1
      })))
    };

    if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
      Shopify.postLink2(theme.routes.cart_add_url, {
        parameters: {
          ...items
        }
      });
      return;
    }

    this.handleErrorMessage();

    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');
    const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

    const body = JSON.stringify({
      ...items,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        if (response.status === 422) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
            detail: {
              errorMessage: response.description
            }
          }));
        }
        else {
          this.miniCart && this.miniCart.renderContents(response);

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: response
            }
          }));
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

    if (this.errorMessageWrapper) {
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    else {
      if (errorMessage) {
        alert(errorMessage);
      }
    }
  }
}
customElements.define('bundle-products', BundleProducts);

class ShopTheLook extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.blockCount == 1) {
      return;
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    this.products = this.querySelector('.image-with-text__products');

    this.blocks = this.querySelectorAll('lookbook-component [data-block-index]');
    this.blocks.forEach((block) => block.addEventListener('mouseenter', this.onEnterHandler.bind(this)));

    this.initSlider();
  }

  onEnterHandler(event) {
    if (this.flickity && typeof this.flickity.select === 'function') {
      const index = parseInt(event.target.dataset.blockIndex);
      this.flickity.select(index);
    }
  }

  onFocusHandler(index) {
    this.blocks.forEach((block) => {
      block.classList.remove('focus');

      if (parseInt(block.dataset.blockIndex) === index) {
        block.classList.add('focus');
      }
    });
  }

  initSlider() {
    this.flickity = new Flickity(this.products, {
      accessibility: false,
      rightToLeft: theme.config.rtl,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      fade: true,
      setGallerySize: true,
      on: {
        ready: () => {
          this.onFocusHandler(0);
        },
        change: (index) => {
          this.onFocusHandler(index);
        }
      }
    });
  }
}
customElements.define('shop-the-look', ShopTheLook);

class SelectWrapper extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });

    this.select = this.querySelector('select');
    if (this.select) {
      this.select.addEventListener('change', this.handleSelectChange.bind(this));
    }
  }

  init() {
    const style = window.getComputedStyle(this.select);
    const value = this.select.options[this.select.selectedIndex].text;

    const text = document.createElement('span');
    text.style.fontFamily = style.fontFamily;
    text.style.fontSize = style.fontSize;
    text.style.fontWeight = style.fontWeight;
    text.style.visibility = 'hidden';
    text.style.position = 'absolute';
    text.innerHTML = value;

    document.body.appendChild(text);
    const width = text.clientWidth;

    this.style.setProperty('--width', `${width}px`);
    text.remove();
  }

  handleSelectChange() {
    this.init();
  }
}
customElements.define('select-wrapper', SelectWrapper);

class ImageComparison extends HTMLElement {
  constructor() {
    super();

    this.active = false;
    this.button = this.querySelector('button');
    this.horizontal = this.dataset.layout === 'horizontal';
    this.bodyStyleOverflowY = document.body.style.overflowY;
    this.init();

    theme.initWhenVisible({
      element: this.querySelector('.image-comparison__animate'),
      callback: this.animate.bind(this),
      threshold: 0
    });
  }

  animate() {
    this.setAttribute('animate', '');
    this.classList.add('animating');
    setTimeout(() => {
      this.classList.remove('animating');
    }, 1e3);
  }

  init() {
    this.button.addEventListener('touchstart', this.startHandler.bind(this));
    document.body.addEventListener('touchend', this.endHandler.bind(this));
    document.body.addEventListener('touchmove', this.onHandler.bind(this));

    this.button.addEventListener('mousedown', this.startHandler.bind(this));
    document.body.addEventListener('mouseup', this.endHandler.bind(this));
    document.body.addEventListener('mousemove', this.onHandler.bind(this));
  }

  startHandler() {
    if (window.innerWidth <= 750) {
      document.body.style.overflowY = 'hidden';
    }

    this.active = true;
    this.classList.add('scrolling');
  }

  endHandler() {
    this.active = false;
    this.classList.remove('scrolling');
    document.body.style.overflowY = this.bodyStyleOverflowY;
  }

  onHandler(e) {
    if (!this.active) return;

    const event = (e.touches && e.touches[0]) || e;
    const x = this.horizontal
      ? event.pageX - this.offsetLeft
      : event.pageY - this.offsetTop;

    this.scrollIt(x);
  }

  scrollIt(x) {
    const distance = this.horizontal ? this.clientWidth : this.clientHeight;

    const max = distance - 20;
    const min = 20;
    const mouseX = Math.max(min, (Math.min(x, max)));
    const mousePercent = (mouseX * 100) / distance;
    this.style.setProperty('--percent', mousePercent + '%');
  }
}
customElements.define('image-comparison', ImageComparison);

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed), // 100px going to move for
      space: 100, // 100px
    };

    this.promotion = this.querySelector('.promotion');

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < 10; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.clone.setAttribute('aria-hidden', true);
        this.appendChild(this.clone);

        const imageWrapper = this.clone.querySelector('.media-wrapper');
        if (imageWrapper) {
          imageWrapper.classList.remove('loading');
        }
      }

      const animationTimeFrame = (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
      this.style.setProperty('--duration', `${animationTimeFrame}s`);

      // pause when out of view
      const observer = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.scrollingPlay();
          } else {
            this.scrollingPause();
          }
        });
      }, { rootMargin: '0px 0px 50px 0px' });

      observer.observe(this);
    }
  }

  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-promotion', ScrollingPromotion);

// class AccordionTab extends HTMLElement {
//   constructor() {
//     super();

//     this.details = this.querySelector('details');
//     this.summary = this.querySelector('summary');
//     this.content = this.querySelector('.accordion__content');

//     this.animation = null;
//     this.isClosing = false;
//     this.isExpanding = false;

//     theme.initWhenVisible({
//       element: this,
//       callback: this.init.bind(this),
//       threshold: 200
//     });
//   }

//   init() {
//     this.summary.addEventListener('click', (e) => this.onClick(e));
//   }

//   onClick(e) {
//     e.preventDefault();

//     if (this.closest('.group-accordion')) {
//       const parent = this.closest('.group-accordion');
//       parent.querySelectorAll('.product__accordion.accordion details').forEach((el) => {
//         if (el !== this.details) {
//           el.removeAttribute('open');
//         }
//       });
//     }

//     this.details.style.overflow = 'hidden';
//     if (this.isClosing || !this.details.open) {
//       this.open();
//     }
//     else if (this.isExpanding || this.details.open) {
//       this.shrink();
//     }
//   }

//   shrink() {
//     this.isClosing = true;

//     const summaryStyle = window.getComputedStyle(this.summary);
//     const startHeight = `${this.details.offsetHeight}px`;
//     const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop)}px`;

//     if (this.animation) {
//       this.animation.cancel();
//     }

//     this.animation = this.details.animate({
//       height: [startHeight, endHeight]
//     }, {
//       duration: 250,
//       easing: 'ease'
//     });

//     this.animation.onfinish = () => this.onAnimationFinish(false);
//     this.animation.oncancel = () => this.isClosing = false;
//   }

//   open() {
//     this.details.style.height = `${this.details.offsetHeight}px`;
//     this.details.open = true;
//     window.requestAnimationFrame(() => this.expand());
//   }

//   expand() {
//     this.isExpanding = true;

//     const summaryStyle = window.getComputedStyle(this.summary);
//     const startHeight = `${this.details.offsetHeight}px`;
//     const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop) + this.content.offsetHeight}px`;

//     if (this.animation) {
//       this.animation.cancel();
//     }

//     this.animation = this.details.animate({
//       height: [startHeight, endHeight]
//     }, {
//       duration: 400,
//       easing: 'ease-out'
//     });
//     this.animation.onfinish = () => this.onAnimationFinish(true);
//     this.animation.oncancel = () => this.isExpanding = false;
//   }

//   onAnimationFinish(open) {
//     this.details.open = open;
//     this.animation = null;
//     this.isClosing = false;
//     this.isExpanding = false;
//     this.details.style.height = this.details.style.overflow = '';
//     const parent = this.details.closest('.accordion');
//     const isGroup = this.details.closest('.group-accordion');
//     if (parent && isGroup) {
//       if (window.innerWidth < 750) {
//         window.scrollTo(0, parent.offsetTop - 54); // reduce by header height
//       } else {
//         window.scrollTo(0, parent.offsetTop - 79); // reduce by header height
//       }
//     }
//   }
// }
// customElements.define('accordion-tab', AccordionTab);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 600px 0px' }).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('product-recommendations', ProductRecommendations);

class HeaderMenuToggle extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector('.shopify-section-header');
    this.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.header.classList.toggle('shopify-section-header-menu-open');
  }
}
customElements.define('header-menu-toggle', HeaderMenuToggle);

class OptionTable extends HTMLElement {
  constructor() {
    super();

    this.config = {
    };

    this.imageOptionRows = this.querySelectorAll(".ot--images .ot--option-row");
    this.dataOptionRows = this.querySelectorAll(".ot--data .ot--option-row");

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    const optionTable = this;

    this.imageOptionRows.forEach((imageOptionRow) => {
      imageOptionRow.addEventListener("mouseenter", function () {
        optionTable.querySelectorAll(".ot--data .ot--option-row").forEach((el) => {
          el.classList.remove("active");
        });
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.opacity = "0.3";
        });
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.zIndex = "initial";
        });

        this.style.opacity = "1";
        this.style.zIndex = "3";

        var imageRowId = this.id;
        var dataRowId = imageRowId.replace("imageRow", "dataRow");
        var activeDataRow = optionTable.querySelector(`#${dataRowId}`);
        activeDataRow.classList.add("active");

        optionTable.querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`).forEach(el => {
          el.classList.remove('active');
        });
        var activeDataRowValues = activeDataRow.querySelectorAll(`:scope div:not(.is-header)`);
        activeDataRowValues.forEach((activeDataRowValue, i) => {
          if (activeDataRowValue.querySelectorAll(`:scope svg.checkmark`).length > 0) {
            optionTable.querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`)[i].classList.add('active');
          }
        });
      });
      imageOptionRow.addEventListener("mouseleave", function () {
        optionTable.querySelectorAll(".ot--data .ot--option-row").forEach((el) => {
          el.classList.remove("active");
        });
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.opacity = "1";
        });
        optionTable.querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`).forEach(el => {
          el.classList.remove('active');
        });
      });
    });

    this.dataOptionRows.forEach((dataOptionRow) => {
      dataOptionRow.addEventListener("mouseenter", function () {
        optionTable.querySelectorAll(".ot--data .ot--option-row").forEach((el) => {
          el.classList.remove("active");
        });
        this.classList.add("active");
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.opacity = "0.3";
        });
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.zIndex = "initial";
        });

        var dataRowId = this.id;
        var imageRowId = dataRowId.replace("dataRow", "imageRow");
        optionTable.querySelector(`#${imageRowId}`).style.opacity = "1";
        optionTable.querySelector(`#${imageRowId}`).style.zIndex = "3";
      });
      dataOptionRow.addEventListener("mouseleave", function () {
        optionTable.querySelectorAll(".ot--data .ot--option-row").forEach((el) => {
          el.classList.remove("active");
        });
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.opacity = "1";
        });
        optionTable.querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`).forEach(el => {
          el.classList.remove('active');
        })
      });
    });
  }
}
customElements.define('option-table', OptionTable);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (this.isTouchDevice) {
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    } else {
      this.addEventListener('mouseenter', this.openSelector.bind(this));
      this.addEventListener('mouseleave', this.hidePanel.bind(this));
    }

    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);

    if (this.classList.contains('on-header')) {
      document.body.classList.remove('localization--open');
    }
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    const isOpen = this.elements.button.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      this.hidePanel();
    } else {
      this.elements.panel.removeAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', 'true');

      if (this.classList.contains('on-header')) {
        document.body.classList.add('localization--open');
      }
    }
  }


  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);



// class StoreSelectorForm extends HTMLElement {
//   constructor() {
//     super();

//     this.elements = {
//       input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
//       button: this.querySelector('button'),
//       panel: this.querySelector('ul'),
//     };

//     this.addEventListener('mouseenter', this.openSelector.bind(this));
//     this.addEventListener('mouseleave', this.hidePanel.bind(this));
//     this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
//   }

//   hidePanel() {
//     this.elements.button.setAttribute('aria-expanded', 'false');
//     this.elements.panel.setAttribute('hidden', true);

//     if (this.classList.contains('on-header')) {
//       document.body.classList.remove('localization--open');
//     }
//   }

//   onContainerKeyUp(event) {
//     if (event.code.toUpperCase() !== 'ESCAPE') return;
//     this.hidePanel();
//   }

//   openSelector() {
//     this.elements.panel.removeAttribute('hidden');
//     this.elements.button.setAttribute('aria-expanded', 'true');

//     if (this.classList.contains('on-header')) {
//       document.body.classList.add('localization--open');
//     }
//   }
// }
// customElements.define('store-selector-form', StoreSelectorForm);


class StoreSelectorForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    this.isMobile = this.checkIfMobile();

    if (this.isMobile) {
      this.elements.button.addEventListener('click', (event) => {
        event.stopPropagation(); // Prevents event bubbling
        this.togglePanel();
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          this.hidePanel();
        }
      });
    } else {
      this.addEventListener('mouseenter', this.openSelector.bind(this));
      this.addEventListener('mouseleave', this.hidePanel.bind(this));
    }

    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  }

  checkIfMobile() {
    return window.matchMedia('(max-width: 990px)').matches; // Adjust breakpoint if needed
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);

    if (this.classList.contains('on-header')) {
      document.body.classList.remove('localization--open');
    }
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
  }

  openSelector() {
    this.elements.panel.removeAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', 'true');

    if (this.classList.contains('on-header')) {
      document.body.classList.add('localization--open');
    }
  }

  togglePanel() {
    const isOpen = this.elements.button.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      this.hidePanel();
    } else {
      this.openSelector();
    }
  }
}

customElements.define('store-selector-form', StoreSelectorForm);


document.addEventListener("DOMContentLoaded", function () {
  var activeLink = document.querySelector('.tab-collections-link.active');
  if (activeLink) {
    activeLink.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }
});

/* customize */
document.addEventListener('page:loaded', function () {
  const viewContent = () => {
    if (typeof ttq !== 'undefined') {
      const productUrl = window.location.pathname;
      fetch(`${productUrl}.json`).then((resp) => resp.json()).then((resp) => {
        const { product } = resp;
        const contents = product.variants.map((variant) => {
          return { content_id: variant.sku, content_type: 'product' };
        });
        ttq.instance('CC3JCE3C77UFTR6UDBJG').track('ViewContent', contents, { event_id: product.id });
      });
    } else {
      setTimeout(() => viewContent(), 1000);
    }
  };

  if (document.body.classList.contains('template-product')) {
    viewContent();
  }
});

const waitFor = (condition, cb, errorCb = null, count = 0, counterLimit = 50) => {
  // only try for 10s
  if (typeof condition === 'function' && typeof cb === 'function' && count < counterLimit) {
    setTimeout(() => {
      if (condition()) {
        cb();
      } else {
        waitFor(condition, cb, errorCb, count + 1, counterLimit);
      }
    }, 200);
  } else if (typeof errorCb === 'function') {
    errorCb();
  }
};

document.querySelectorAll('.card-information .bottomLine').forEach((el) => {
  if (el) {
    const url = el.getAttribute('data-url');
    waitFor(() => el.querySelector('a'), () => {
      const link = el.querySelector('a');
      el.querySelector('a')?.setAttribute('href', url);
    });
  }
});

if (window.location.href.includes('/products/') && window.location.href.includes('#write-a-review')) {
  document.querySelector('.yotpo-main-widget').scrollIntoView({ behavior: 'smooth' });
}

function removeHideClasses() {
  const sectionElement = document.querySelector('section.survey--customer.hide');
  const sectionElement2 = document.querySelector('.section-two-image.hide');
  const sectionElement3 = document.querySelector('.newsletter.hide');
  const sectionElement4 = document.querySelector('.page-review-carousel.hide');

  if (sectionElement) {
    sectionElement.classList.remove('hide');
  }
  if (sectionElement2) {
    sectionElement2.classList.remove('hide');
  }
  if (sectionElement3) {
    sectionElement3.classList.remove('hide');
  }
  if (sectionElement4) {
    sectionElement4.classList.remove('hide');
  }
}

function checkUrlAndModifyFooter() {
  const currentUrl = window.location.href;
  const footerElement = document.querySelector('footer.footer');

  const quizQuestionUrls = [
    '/pages/custom-skin-quiz/question-1',
    '/pages/custom-skin-quiz/question-2',
    '/pages/custom-skin-quiz/question-3',
    '/pages/custom-skin-quiz/question-4',
    '/pages/custom-skin-quiz/question-5',
    '/pages/custom-skin-quiz/question-6',
    '/pages/custom-skin-quiz/question-7',
    'pages/custom-skin-quiz'
  ];

  const shouldHideFooter = quizQuestionUrls.some(url => currentUrl.includes(url))
    && !currentUrl.includes('/pages/custom-skin-quiz/result');

  if (footerElement) {
    if (shouldHideFooter) {
      footerElement.classList.add('hide');
    } else {
      footerElement.classList.remove('hide');
    }
  }
}

function checkUrlAndRemoveHideClasses() {
  const currentUrl = window.location.href;

  if (currentUrl.includes('/pages/quiz/result')) {
    removeHideClasses();
  }
}

function skincheckUrlAndRemoveHideClasses() {
  const currentUrl2 = window.location.href;
  const showdata = document.querySelector('.footer__blocks-wrapper footer-accordion .footer-block-image');

  if (currentUrl2.includes('/pages/custom-skin-quiz/result')) {
    removeHideClasses();
    showdata.style.maxHeight = "100%";
  }
}

function handleUrlChange() {
  checkUrlAndRemoveHideClasses();
  skincheckUrlAndRemoveHideClasses();
  checkUrlAndModifyFooter();
}

document.addEventListener("DOMContentLoaded", function () {
  handleUrlChange();
});

window.addEventListener('popstate', function () {
  handleUrlChange();
});

const originalPushState = history.pushState;
history.pushState = function () {
  originalPushState.apply(this, arguments);
  handleUrlChange();
};

const originalReplaceState = history.replaceState;
history.replaceState = function () {
  originalReplaceState.apply(this, arguments);
  handleUrlChange();
};

document.querySelectorAll('.menu-drawer__navigation .child-link').forEach(details => {
  details.addEventListener('toggle', function () {
    const parentNav = this.closest('.menu-drawer__navigation');
    const localizationDiv = document.querySelector('.menu-drawer__localization');

    if (this.open) {
      parentNav.querySelectorAll('.child-link').forEach(otherDetails => {
        if (otherDetails !== this) otherDetails.open = false;
      });
      parentNav.classList.add('has-open-child');
      if (localizationDiv) localizationDiv.classList.add('has-open-menu');
    } else {

      const hasOpenChild = parentNav.querySelector('.child-link[open]') !== null;

      parentNav.classList.toggle('has-open-child', hasOpenChild);
      if (localizationDiv) localizationDiv.classList.toggle('has-open-menu', hasOpenChild);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll('[id^="Slider-"]');

  sliders.forEach(slider => {
    const prevBtn = slider.parentElement.querySelector('.slider-button--prev');
    const nextBtn = slider.parentElement.querySelector('.slider-button--next');

    if (!prevBtn || !nextBtn) return; // Skip this slider if buttons are missing

    const scrollAmount = slider.querySelector('.grid__item')?.offsetWidth || 300;

    prevBtn.addEventListener('click', () => {
      slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
    const updateButtons = () => {
      const scrollLeft = slider.scrollLeft;
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;

      prevBtn.disabled = scrollLeft <= 0;
      nextBtn.disabled = scrollLeft >= maxScrollLeft;
    };
    updateButtons();

    slider.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const recoverLink = document.querySelector('.forget-cancel-btn');
  const forgotLink = document.querySelector('a[href="#recover"]');

  const loginForm = document.getElementById('login-form');
  const recoverForm = document.getElementById('recover-form');

  if (forgotLink) {
    forgotLink.addEventListener('click', function (e) {
      e.preventDefault();
      loginForm.style.display = 'none';
      recoverForm.style.display = 'block';
      const recoverHeader = document.getElementById('recover');
      if (recoverHeader) {
        recoverHeader.style.display = 'block';
      }
      if (recoverHeader && recoverHeader.nextElementSibling) {
        recoverHeader.nextElementSibling.style.display = 'block';
      }
    });
  }

  if (recoverLink) {
    recoverLink.addEventListener('click', function (e) {
      e.preventDefault();
      recoverForm.style.display = 'none';
      loginForm.style.display = 'block';
    });
  }
});

/* MY account */

document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.dashboard-tab');
  const sections = ['orders-section', 'address-section'];
  const mobileContainer = document.querySelector('.Mobile-Dashboard-container');
  const mobileOptions = document.querySelectorAll('.mobile-option');
  const desktopContainer = document.querySelector('.Dashboard-container');
  const mobileHr = document.querySelector('hr.mobile-show');
  let lastActiveTarget = null;

  function showDesktopOnly() {
    if (desktopContainer) desktopContainer.style.display = 'block';
    if (mobileContainer) mobileContainer.style.display = 'none';
    if (mobileHr) mobileHr.style.display = 'none';
  }

  function showMobileOnly() {
    if (desktopContainer) desktopContainer.style.display = 'none';
    if (mobileContainer) mobileContainer.style.display = 'block';
    if (mobileHr) mobileHr.style.display = 'block';
  }

  function activateTab(targetId) {
    lastActiveTarget = targetId;

    sections.forEach(id => {
      const section = document.getElementById(id);
      if (section) section.classList.toggle('active', id === targetId);
    });

    tabs.forEach(tab => {
      tab.classList.toggle('active', tab.getAttribute('data-target') === targetId);
    });

    mobileOptions.forEach(option => {
      option.classList.toggle('active', option.getAttribute('data-target') === targetId);
    });

    // Update mobile dropdown summary text
    if (mobileContainer) {
      const selectedOption = Array.from(mobileOptions).find(opt =>
        opt.getAttribute('data-target') === targetId
      );
      if (selectedOption) {
        mobileContainer.querySelector('summary').innerHTML = `
          ${selectedOption.textContent}
          <span class="show-arrow"> </span>
        `;
      }
    }

    if (window.innerWidth <= 750) {
      showMobileOnly();
    }

    // Close the details dropdown after selection
    if (mobileContainer) {
      mobileContainer.removeAttribute('open');
    }
  }

  function resetToDashboard() {
    lastActiveTarget = null;

    sections.forEach(id => {
      const section = document.getElementById(id);
      if (section) section.classList.remove('active');
    });

    tabs.forEach(tab => tab.classList.remove('active'));

    if (mobileContainer) {
      mobileContainer.querySelector('summary').textContent = 'Dashboard';
    }

    showDesktopOnly();
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      const targetId = this.getAttribute('data-target');
      activateTab(targetId);
    });
  });

  mobileOptions.forEach(option => {
    option.addEventListener('click', function () {
      const target = this.getAttribute('data-target');
      target ? activateTab(target) : resetToDashboard();
    });
  });

  function handleResponsiveLayout() {
    if (window.innerWidth <= 750) {
      if (lastActiveTarget) {
        showMobileOnly();
      } else {
        showDesktopOnly();
      }
    } else {
      showDesktopOnly();
      if (lastActiveTarget) {
        const tab = document.querySelector(`[data-target="${lastActiveTarget}"]`);
        if (tab) tab.click();
      }
    }
  }

  // ✅ Activate the first tab by default on desktop
  if (window.innerWidth > 750) {
    const firstTab = tabs[0];
    if (firstTab) {
      const targetId = firstTab.getAttribute('data-target');
      activateTab(targetId);
    }
  } else {
    resetToDashboard();
  }

  handleResponsiveLayout();
  window.addEventListener('resize', handleResponsiveLayout);
});



document.addEventListener('DOMContentLoaded', function () {
  const addAddressBtn = document.querySelector('.add-address');
  const addAddressForm = document.getElementById('AddAddress');
  let activeForm = null;

  function closeAllForms() {
    if (addAddressForm) {
      addAddressForm.style.display = 'none';
    }
    if (addAddressBtn) {
      addAddressBtn.setAttribute('aria-expanded', 'false');
    }
    document.querySelectorAll('div[id^="EditAddress_"]').forEach(form => {
      form.style.display = 'none';
    });

    document.querySelectorAll('.edit').forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });

    const container = document.querySelector('.address-entry');
    if (container) {
      container.style.height = '';
    }

    activeForm = null;
  }

  function updateContainerHeight() {
    if (!activeForm) return;

    const container = document.querySelector('.address-entry');
    if (!container) return;

    requestAnimationFrame(() => {
      const formHeight = activeForm.offsetHeight;
      container.style.height = formHeight + 'px';
    });
  }

  // Handle window resize
  window.addEventListener('resize', updateContainerHeight);

  if (addAddressBtn && addAddressForm) {
    addAddressBtn.addEventListener('click', function () {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        closeAllForms();
        return;
      }

      closeAllForms();
      this.setAttribute('aria-expanded', 'true');
      addAddressForm.style.display = 'block';
      activeForm = addAddressForm; // Set as active form

      updateContainerHeight();
    });

    const cancelBtn = addAddressForm.querySelector('button[type="reset"]');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', closeAllForms);
    }
  }

  document.querySelectorAll('.edit').forEach(button => {
    button.addEventListener('click', function () {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      const addressId = this.getAttribute('data-address-id');
      const targetForm = document.getElementById(`EditAddress_${addressId}`);

      if (isExpanded) {
        closeAllForms();
        return;
      }

      closeAllForms();
      if (targetForm) {
        this.setAttribute('aria-expanded', 'true');
        targetForm.style.display = 'block';
        activeForm = targetForm;

        updateContainerHeight();
      }
    });
  });

  document.querySelectorAll('.cancel').forEach(cancelBtn => {
    cancelBtn.addEventListener('click', closeAllForms);
  });

  document.querySelectorAll('.reset-icon').forEach(icon => {
    icon.addEventListener('click', closeAllForms);
  });
});


// function deleteAddress(button) {
//   if (confirm(button.getAttribute('data-confirm-message'))) {

//     const store_url = theme.shopSettings.store_url;

//     console.log(`${store_url}/account`,"shgdsgjah");

//     fetch(button.getAttribute('data-target'), {
//       method: 'DELETE',
//       headers: { 'X-Requested-With': 'XMLHttpRequest' },
//     })
//       .then(response => {
//         if (response.ok) {
//           window.location.href = `${store_url}/account`;
//         } else {
//           window.location.href = `${store_url}/account`;
//         }
//       });
//   }
// }

let addressToDelete = null;

document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.querySelector('.delete-overlay');
  const deleteBox = document.querySelector('.address-delete-div');
  const body = document.body;

  document.querySelectorAll('.button.delete').forEach(button => {
    button.addEventListener('click', function () {
      addressToDelete = button;
      overlay.style.display = 'flex';
      body.style.overflow = 'hidden';
    });
  });

  document.querySelectorAll('.cancel-delete, .popup-close').forEach(el => {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      overlay.style.display = 'none';
      body.style.overflow = '';
      addressToDelete = null;
    });
  });

  document.querySelectorAll('.yes-delete').forEach(button => {
    button.addEventListener('click', function () {
      if (addressToDelete) {
        deleteAddress(addressToDelete);
      }
    });
  });

  overlay?.addEventListener('click', function (e) {
    if (!deleteBox.contains(e.target)) {
      overlay.style.display = 'none';
      body.style.overflow = '';
      addressToDelete = null;
    }
  });
});

function deleteAddress(button) {
  const store_url = theme.shopSettings.store_url;

  fetch(button.getAttribute('data-target'), {
    method: 'DELETE',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  }).then(response => {
    window.location.href = `${store_url}/account`;
  });
}


function submitFormAndRedirect() {
  const form = document.querySelector('#AddAddress form');

  const store_url = theme.shopSettings.store_url;

  // console.log(`${store_url}/account`, "shgdsgjah");

  if (form) {
    form.submit();
    setTimeout(() => {
      window.location.href = `${store_url}/account`;
    }, 500);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  function setupValidation(containerSelector, buttonSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const form = container.querySelector('form');
    if (!form) return;

    const submitButton = form.querySelector(buttonSelector);
    const requiredFields = form.querySelectorAll('input[required]');

    function validateForm() {
      const allFilled = Array.from(requiredFields).every(field => field.value.trim() !== '');
      submitButton.disabled = !allFilled;
    }

    validateForm();

    requiredFields.forEach(field => {
      field.addEventListener('input', validateForm);
    });
  }
  setupValidation('form-state.register-form', '.register-btn');
  setupValidation('form-state.login-form', '.login-btn');
});

function handleVariantUpdate(event) {
  const form = document.querySelector(".js-back-in-stock");
  const emailInput = form?.querySelector("input[name='variant_id']");
  if (!emailInput || !event) return;

  const variant = event;
  emailInput.value = event.id;

  const productAvailable = variant.available;
  const buyButtonWrap = document.querySelector(".product-form__buttons");
  const klaviyoForm = document.querySelector("klaviyo-form");
  const ProductSuffix = klaviyoForm.dataset.templatesuffix;


  if (productAvailable == false) {
    if (ProductSuffix != "pre-order") {
      buyButtonWrap?.classList.add("hidden");
      klaviyoForm?.classList.remove("hidden");
    } else {
      buyButtonWrap?.classList.remove("hidden");
      klaviyoForm?.classList.add("hidden");
    }
  } else {
    buyButtonWrap?.classList.remove("hidden");
    klaviyoForm?.classList.add("hidden");
  }
}

// klaviyo-back-in-stock.js
const klaviyoBackinStock = (klaviyoform) => {
  const stockForm = document.querySelectorAll(".js-back-in-stock");
  if (stockForm.length) {
    stockForm.forEach(function (formElem) {
      formElem.addEventListener("submit", (e) => {
        e.preventDefault();
        const formData = new FormData(formElem); 
        const email = formData.get("email");
        const variant_id = formData.get("variant_id");
        // console.log("------", variant_id, email);
        const errorElem = formElem.querySelector(".klaviyo-error");

        // Email validation
        if (!validateEmail(email)) {
          if (errorElem) errorElem.classList.remove("hidden");
          return;
        } else {
          if (errorElem) errorElem.classList.add("hidden");
        }

        callKlaviyo(email, variant_id, formElem);
      });

      formElem.addEventListener("formdata", (e) => {
        const formData = e.formData;
        formData.set("email", formData.get("email"));
        formData.set("variant_id", formData.get("variant_id"));
      });
    });
  }

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email.toLowerCase());
  }
  function getErrorMessage(status) {
    switch (status) {
      case 400: return "Something went wrong. Please check your email and try again.";
      case 401: return "We couldn't process your request right now. Please try again later.";
      case 403: return "Unable to subscribe at the moment. Please try again later.";
      case 404: return "This product variant cannot be subscribed right now.";
      case 409: return "You are already subscribed for restock alerts.";
      case 429: return "Too many attempts. Please try again after a moment.";
      case 500: return "Server error. Please try again shortly.";
      default: return "Something went wrong. Please try again.";
    }
  }
  async function callKlaviyo(email, variant_id, formElem) {
    if (!email || !variant_id) return;

    const options = {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'revision': '2025-01-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email
                }
              }
            },
            channels: ["EMAIL"]
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: '$shopify:::$default:::' + parseInt(variant_id)
              }
            }
          }
        }
      })
    };

    const cmpid = window.routes.klaviyo_account;
    const errorElem = klaviyoform.querySelector(".klaviyo-error-res");
    // console.log(cmpid,"Cmpid");

    // console.log("Payload:", JSON.stringify(options.body, null, 2));
    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${cmpid}`, options)
      .then(response => response)
      .then(response => {
        var variant = klaviyoform.querySelector(`[value="${parseInt(variant_id)}"]`);
        if (response.ok) {
          if (variant) {
            klaviyoform.querySelector(".klaviyo-form-wrap")?.classList.add("hidden");
            klaviyoform.querySelector(".show-waitlist-container")?.classList.add("hideen");
            klaviyoform.querySelector(".restock-alert")?.classList.remove("hidden");
            klaviyoform.querySelector(".selected-product-form")?.classList.remove('hide');
            klaviyoform.classList.add("product-show");
          }
        } else {
          console.error("Error: HTTP status", response.status);
          klaviyoform.querySelector(".klaviyo-error-res")?.classList.remove("hidden");
          errorElem.innerHTML = getErrorMessage(response.status);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
};


class KlaviyoForm extends HTMLElement {
  constructor() {
    super();
    klaviyoBackinStock(this);
  }
}
customElements.define("klaviyo-form", KlaviyoForm);



document.addEventListener('DOMContentLoaded', () => {
  const btns = document.querySelectorAll('.waitlist-btn');
  const modal = document.getElementById('waitlist-form-data');
  const tabSection = document.querySelector('.collection-tabbing-section');

  btns.forEach(btn => {
    const id = btn.dataset.productId;
    const originalForm = document.querySelector(`#waitlist-overlay-${id}`);

    btn.addEventListener('click', () => {
      if (!originalForm) return;

      // clone and insert the form HTML
      const clone = originalForm.cloneNode(true);

      // Remove display: none from the clone
      clone.style.display = 'flex';

      modal.innerHTML = '';
      modal.appendChild(clone);
      modal.style.display = 'flex';

      // show modal overlay
      document.body.classList.add('overlay-add');
      tabSection?.classList.add('waitlist-overlay-add');
      document.body.classList.add('no-scroll');

      const klaviyoForm = clone.querySelector("klaviyo-form");
      if (klaviyoForm) {
        klaviyoBackinStock(klaviyoForm); // manually call your function
      }

      // reattach close button listener
      modal.querySelector('.waitlist-close-btn')
        ?.addEventListener('click', closeModal);
    });
  });

  function closeModal() {
    modal.style.display = 'none';
    document.body.classList.remove('overlay-add');
    tabSection?.classList.remove('waitlist-overlay-add');
    document.body.classList.remove('no-scroll');
  }

  modal.addEventListener('click', e => {
    if (e.target === modal) closeModal();
  });
});




function setupDiscountHandlers() {
  const discountCodeInput = document.getElementById("discountCodeInput");
  const applyDiscountBtn = document.getElementById("applyDiscountBtn");
  const removeDiscountBtn = document.getElementById("removeDiscountBtn");
  const successDiv = document.querySelector(".discount-success");
  const errorDiv = document.querySelector(".discount-error");
  const loadingOverlay = document.querySelector(".discount-success-wrapper .loading-overlay");
  const is_login = window.customer?.is_login;
  const firstOrder = window.customer?.first_order;

  const aplGiftCode = window.first_gift?.apl_discount_code;
  const freeVariant = window.first_gift?.apl_free_product;
  window.miniCart = document.querySelector("mini-cart");

  if (
    discountCodeInput &&
    applyDiscountBtn &&
    removeDiscountBtn &&
    !applyDiscountBtn.dataset.listenerAttached
  ) {
    applyDiscountBtn.dataset.listenerAttached = "true"; // Prevent multiple attachments

    async function refreshCartDrawer() {
      const sectionList = window.miniCart?.getSectionsToRender?.() || [];
      const sectionIds = sectionList.map((section) => section.id);

      if (!sectionIds.length) {
        console.warn("No cart sections to refresh");
        return await fetch("/cart.js").then((res) => res.json());
      }

      const res = await fetch(`/cart?sections=${sectionIds.join(",")}`);
      const htmlSections = await res.json();

      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();
      cart.sections = htmlSections;

      if (window.miniCart && typeof miniCart.renderContents === "function") {
        miniCart.renderContents(cart);
      }

      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: { cart },
        })
      );

      return cart;
    }

    async function updateCartUI(cart = null) {
      if (!cart) {
        const res = await fetch("/cart.js");
        cart = await res.json();
      }

      const discountCode = cart.discount_codes?.[0]?.code || "";
      const applicable = cart.discount_codes?.[0]?.applicable;

      if (discountCode && applicable) {
        successDiv.textContent = `${discountCode}`;
        discountCodeInput.disabled = true;
        discountCodeInput.value = discountCode;
        applyDiscountBtn.disabled = true;
        removeDiscountBtn.style.display = "inline-block";
      } else {
        successDiv.textContent = "";
        discountCodeInput.disabled = false;
        discountCodeInput.value = "";
        applyDiscountBtn.disabled = false;
        removeDiscountBtn.style.display = "none";
      }
    }

    async function applyDiscount() {
      if (window._isAddingGift) return;
      window._isAddingGift = true;

      const discountCode = discountCodeInput.value.trim();
      if (!discountCode) {
        errorDiv.textContent = "Please enter a discount code";
        successDiv.textContent = "";
        applyDiscountBtn.disabled = false;
        applyDiscountBtn.textContent = "Apply";
        window._isAddingGift = false;
        return;
      }


      applyDiscountBtn.disabled = true;
      applyDiscountBtn.textContent = "Applying...";
      errorDiv.textContent = "";
      successDiv.textContent = "";

      const formData = new FormData();
      formData.append("discount", discountCode);

      try {
        await fetch("/cart/update.js", {
          method: "POST",
          body: formData,
        });

        let cart = await fetch("/cart.js").then((res) => res.json());
        const appliedDiscountCode = cart.discount_codes?.[0]?.code;
        const applicable = cart.discount_codes?.[0]?.applicable;

        // let cart = await fetch("/cart.js").then((res) => res.json());

        const appliedCodes = cart.discount_codes || [];

        const normalizedEnteredCode = discountCode.toLowerCase();
        const matchedCode = appliedCodes.find(
          (codeObj) =>
            codeObj.code?.toLowerCase() === normalizedEnteredCode
        );


        // console.log("Discount Codes in Cart:", cart.discount_codes); 

        if (matchedCode && matchedCode.applicable) {
          successDiv.textContent = `${discountCode}`;
          discountCodeInput.disabled = true;
          applyDiscountBtn.disabled = true;
          removeDiscountBtn.style.display = "inline-block";

          if (
            aplGiftCode &&
            freeVariant &&
            discountCode.toLowerCase() === aplGiftCode.toLowerCase()
          ) {
            const isGiftInCart = cart.items.some(
              (item) =>
                item.id === parseInt(freeVariant) &&
                item.properties?._checkout_ui === "1" &&
                item.properties?._welcome_free == freeVariant
            );

            if (!isGiftInCart && firstOrder && is_login) {
              const props = {
                _checkout_ui: "1",
                _welcome_free: freeVariant,
                _gift_prop: true,
              };

              await fetch(`${window.routes.cart_add_url}.js`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: parseInt(freeVariant),
                      quantity: 1,
                      properties: props,
                    },
                  ],
                }),
              });

              cart = await refreshCartDrawer();
            } else {
              await refreshCartDrawer();
            }
          } else {
            await refreshCartDrawer();
          }
        } else {
          errorDiv.textContent = "Code not matched or invalid";

        }
      } catch (err) {
        console.error(err);
        errorDiv.textContent = "Error applying discount. Please try again.";
      } finally {
        applyDiscountBtn.disabled = false;
        applyDiscountBtn.textContent = "Apply";
        window._isAddingGift = false;
      }
    }

    async function removeDiscount() {
      removeDiscountBtn.disabled = true;
      loadingOverlay?.classList.remove("hidden");

      const formData = new FormData();
      formData.append("discount", "");

      try {
        await fetch("/cart/update.js", {
          method: "POST",
          body: formData,
        });

        let cart = await fetch("/cart.js").then((res) => res.json());

        if (aplGiftCode && freeVariant) {
          const apl_giftItem = cart.items.find(
            (item) =>
              item.id === parseInt(freeVariant) &&
              item.properties?._checkout_ui === "1"
          );

          if (apl_giftItem) {
            await fetch(`${window.routes.cart_change_url}.js`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: apl_giftItem.key,
                quantity: 0,
              }),
            });
          }
        }

        await refreshCartDrawer();

        successDiv.textContent = "";
        errorDiv.textContent = "";
        discountCodeInput.disabled = false;
        discountCodeInput.value = "";
        applyDiscountBtn.disabled = false;
        removeDiscountBtn.disabled = true;
        removeDiscountBtn.style.display = "none";
      } catch (err) {
        console.error(err);
        errorDiv.textContent = "Error removing discount.";
      } finally {
        removeDiscountBtn.disabled = false;
        removeDiscountBtn.textContent = "✕";
        loadingOverlay?.classList.add("hidden");
      }
    }

    function attachEventListeners() {
      applyDiscountBtn.removeEventListener("click", handleApplyClick);
      removeDiscountBtn.removeEventListener("click", handleRemoveClick);
      discountCodeInput.removeEventListener("keypress", handleKeyPress);

      applyDiscountBtn.addEventListener("click", handleApplyClick);
      removeDiscountBtn.addEventListener("click", handleRemoveClick);
      discountCodeInput.addEventListener("keypress", handleKeyPress);
    }

    function handleApplyClick(e) {
      e.preventDefault();
      applyDiscount();
    }

    function handleRemoveClick(e) {
      e.preventDefault();
      removeDiscount();
    }

    function handleKeyPress(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        applyDiscount();
      }
    }

    attachEventListeners();
    updateCartUI();

    document.addEventListener("cart:updated", (e) => {
      updateCartUI(e.detail.cart);
      attachEventListeners();
    });

    document.addEventListener("cart:request:completed", () => {
      updateCartUI();
      attachEventListeners();
    });
  }
}



// Initial setup on page load
setupDiscountHandlers();

// Re-run when cart is updated
document.addEventListener("cart:request:completed", setupDiscountHandlers);
document.addEventListener("cart:updated", setupDiscountHandlers);

// Dynamically detect if the discount code section is added later
const observer = new MutationObserver(() => {
  setupDiscountHandlers();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


async function checkAndRemoveGiftIfAlone() {
  const aplGiftCode = window.first_gift?.apl_discount_code;
  const freeVariant = window.first_gift?.apl_free_product;

  const cart = await fetch("/cart.js").then((res) => res.json());

  // If only 1 item is in cart
  if (cart.items.length === 1) {
    const onlyItem = cart.items[0];

    const isGiftOnly =
      onlyItem.id === parseInt(freeVariant) &&
      onlyItem.properties?._checkout_ui === "1" &&
      onlyItem.properties?._welcome_free == freeVariant;

    const hasGiftCode = cart.discount_codes?.some(
      (code) => code.code?.toLowerCase() === aplGiftCode?.toLowerCase()
    );

    if (isGiftOnly && hasGiftCode) {
      // console.log("🧹 Removing gift and discount code since only gift remains");

      // Remove discount code
      const formData = new FormData();
      formData.append("discount", "");
      await fetch("/cart/update.js", {
        method: "POST",
        body: formData,
      });

      // 🔁 Re-fetch cart with item key
      const refreshedCart = await fetch("/cart.js").then((res) => res.json());
      const updatedGiftItem = refreshedCart.items.find(
        (item) =>
          item.id === parseInt(freeVariant) &&
          item.properties?._checkout_ui === "1" &&
          item.properties?._welcome_free == freeVariant
      );

      if (updatedGiftItem && updatedGiftItem.key) {
        // Now safe to remove by key
        await fetch(`${window.routes.cart_change_url}.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: updatedGiftItem.key,
            quantity: 0,
          }),
        });

        await refreshCartDrawer();
      }
    }
  }
}
async function refreshCartDrawer() {
  const sectionList = window.miniCart?.getSectionsToRender?.() || [];
  const sectionIds = sectionList.map((section) => section.id);

  if (!sectionIds.length) {
    console.warn("No cart sections to refresh");
    return await fetch("/cart.js").then((res) => res.json());
  }

  const res = await fetch(`/cart?sections=${sectionIds.join(",")}`);
  const htmlSections = await res.json();

  const cartRes = await fetch("/cart.js");
  const cart = await cartRes.json();
  cart.sections = htmlSections;

  if (window.miniCart && typeof miniCart.renderContents === "function") {
    miniCart.renderContents(cart);
  }

  document.dispatchEvent(
    new CustomEvent("cart:updated", {
      detail: { cart },
    })
  );

  return cart;
}

document.addEventListener("DOMContentLoaded", () => {
  const stickyWaitlistBtn = document.querySelector(".sticky-cart__form .waitlist-btn");

  if (stickyWaitlistBtn) {
    stickyWaitlistBtn.addEventListener("click", () => {
      const scrollToBis = () => {
        const bisSection = document.querySelector(".pdp-back-in-stock, .show-waitlist-container");
        if (bisSection) {
          const headerOffset = 100;
          const elementPosition = bisSection.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
          return true;
        }
        return false;
      };

      if (!scrollToBis()) {
        const observer = new MutationObserver(() => {
          if (scrollToBis()) observer.disconnect();
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname === "/pages/skin-quiz") {
    const footer = document.querySelector("footer");
    if (footer) {
      footer.classList.add("hidden-footer");
      footer.style.display = "none";
    }
  }
});

(() => {
  function tryRefresh() {
    if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
      try {
        window.yotpo.refreshWidgets();
      } catch (err) {
        console.warn('yotpo.refreshWidgets() threw:', err);
      }
      return true;
    }
    return false;
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(() => {
    if (!tryRefresh()) {
      let attempts = 0;
      const maxAttempts = 20;
      const t = setInterval(() => {
        attempts++;
        if (tryRefresh() || attempts >= maxAttempts) clearInterval(t);
      }, 300);
    }
  });

  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (!(n instanceof HTMLElement)) continue;
        if (n.matches('.yotpo-widget-instance') || n.querySelector && n.querySelector('.yotpo-widget-instance')) {
          tryRefresh();
          return;
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', () => {
    setTimeout(tryRefresh, 50);
  });

})();

  // Reload page when coming from checkout
  (function() {
    try {
      // console.log('[Checkout Reload] Starting check...');
      // console.log('[Checkout Reload] Current URL:', window.location.href); 
      // console.log('[Checkout Reload] All sessionStorage:', JSON.stringify(sessionStorage));
      
      // Set flag when navigating TO checkout - use beforeunload for reliability
      window.addEventListener('beforeunload', function() { 
        var currentUrl = window.location.href || ''; 
        var currentPath = window.location.pathname || ''; 
        // console.log('[Checkout Reload] beforeunload - URL:', currentUrl);
        
        // If we're leaving a non-checkout page, might be going to checkout
        if (currentPath.indexOf('/checkout') === -1 && currentPath.indexOf('/checkouts') === -1) {
          if (typeof Shopify === 'undefined' || !Shopify.Checkout) {
            // console.log('[Checkout Reload] beforeunload - Setting flag (leaving non-checkout page)');
            sessionStorage.setItem('went_to_checkout', '1');
            sessionStorage.setItem('checkout_timestamp', Date.now().toString());
          }
        }
      });
      
      // Also set flag on form submit
      document.addEventListener('submit', function(e) {
        var form = e.target;
        if (form && form.action) {
          var action = form.action.toLowerCase();
          if (action.indexOf('/cart') !== -1 || action.indexOf('/checkout') !== -1) {
            var checkoutInput = form.querySelector('input[name="checkout"]');
            if (checkoutInput && checkoutInput.value === 'Checkout') {
              // console.log('[Checkout Reload] Form submit - Setting flag');
              sessionStorage.setItem('went_to_checkout', '1');
              sessionStorage.setItem('checkout_timestamp', Date.now().toString());
            }
          }
        }
      }, true);
      
      // Function to check and reload
      function checkAndReload() {
        var wentToCheckout = sessionStorage.getItem('went_to_checkout');
        var checkoutTimestamp = sessionStorage.getItem('checkout_timestamp');
        // console.log('[Checkout Reload] Went to checkout flag:', wentToCheckout);
        // console.log('[Checkout Reload] Checkout timestamp:', checkoutTimestamp);
        
        // Don't run on checkout pages - but DON'T clear the flag here
        if (typeof Shopify !== 'undefined' && Shopify.Checkout) {
          // console.log('[Checkout Reload] On checkout page, keeping flag');
          return;
        }
        
        var currentPath = window.location.pathname || '';
        // console.log('[Checkout Reload] Current path:', currentPath);
        
        if (currentPath.indexOf('/checkout') !== -1 || currentPath.indexOf('/checkouts') !== -1) {
          // console.log('[Checkout Reload] Path contains checkout, keeping flag');
          return;
        }
        
        // If we went to checkout and we're back, reload
        if (wentToCheckout === '1') {
          var hasReloaded = sessionStorage.getItem('reloaded_from_checkout');
          // console.log('[Checkout Reload] Has already reloaded?', hasReloaded);
          
          if (!hasReloaded) {
            // console.log('[Checkout Reload] Returning from checkout via back button - reloading...');
            sessionStorage.setItem('reloaded_from_checkout', '1');
            sessionStorage.removeItem('went_to_checkout');
            sessionStorage.removeItem('checkout_timestamp');
            window.location.reload();
          } else {
            // console.log('[Checkout Reload] Already reloaded, clearing flags');
            sessionStorage.removeItem('went_to_checkout');
            sessionStorage.removeItem('checkout_timestamp');
            sessionStorage.removeItem('reloaded_from_checkout');
          }
        } else {
          // console.log('[Checkout Reload] Not returning from checkout - flag not set');
          sessionStorage.removeItem('reloaded_from_checkout');
        }
      }
      
      // Check immediately
      checkAndReload();
      
      // Handle back button (pageshow event)
      window.addEventListener('pageshow', function(e) {
        // console.log('[Checkout Reload] pageshow event, persisted:', e.persisted);
        setTimeout(checkAndReload, 100);
      });
      
    } catch (e) {
      // console.error('[Checkout Reload] Error:', e);
    }
  })();
